(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Teacher = require('./Teacher');

var _Teacher2 = _interopRequireDefault(_Teacher);

var _PostCollection = require('./../plugins/wordpress-posts/PostCollection');

var _PostCollection2 = _interopRequireDefault(_PostCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    props: {
        comment: {
            required: true
        }
    },

    computed: {
        hasContent: function hasContent() {
            return this.comment.content !== '';
        }
    },

    data: function data() {
        return {
            loading: false,
            contentReady: false
        };
    },
    created: function created() {
        var _this = this;

        this.comment.content = '';

        Event.$on('teacher-detail-was-closed', function () {
            _this.contentReady = false;
        });
    },


    methods: {
        title: function title() {

            var content = this.comment.comment_content;
            var m = content.match(/<strong>(.*?)<\/strong>/i);
            content = (m !== null ? m[1] : content).replace(/(\(|（).*(\)|）)/g, '');

            return content;
        },
        onClick: function onClick() {
            var _this2 = this;

            if (this.contentReady) {
                return;
            }

            this.loading = true;

            // コメントの本体となるPOSTのIDを類推する（URLのルールが変われば失敗する可能性ある）
            var comment_post_id = this.postId();

            //ビギンにおけるコメントは本体となるPostが存在するので、その本体取得する
            this.$http.get('/comment/' + comment_post_id).then(function (response) {

                _this2.comment.content = response.data.content;

                _this2.loading = false;

                _this2.contentReady = true;
            }).catch(function (err) {
                console.error(err);
            });
        },
        postId: function postId() {
            var m = this.comment.comment_author_url.match(/(\d+).php/i);
            if (m === null) {
                return;
            }

            return m[1];
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n\n<div :id=\"'comment-'+postId()\">\n    <i class=\"communication\"></i>\n\n    <strong v-if=\"contentReady\" v-html=\"title()\"></strong>\n    <a href=\"#\" v-html=\"title()\" @click.prevent.stop=\"onClick()\" v-else=\"\"></a>\n\n    <span v-show=\"loading\" class=\"loader loader__facebook\"></span>\n\n    <transition name=\"slide-fade--up\">\n        <div class=\"comment-content\" v-show=\"contentReady\" v-html=\"comment.content\">\n        </div>\n    </transition>\n</div>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-da22593e", module.exports)
  } else {
    hotAPI.update("_v-da22593e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./../plugins/wordpress-posts/PostCollection":23,"./Teacher":8,"vue":31,"vue-hot-reload-api":30}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Teacher = require('./Teacher');

var _Teacher2 = _interopRequireDefault(_Teacher);

var _PostCollection = require('./../plugins/wordpress-posts/PostCollection');

var _PostCollection2 = _interopRequireDefault(_PostCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    props: {
        comment: {
            required: true
        }
    },

    computed: {
        hasContent: function hasContent() {
            return this.comment.content !== '';
        }
    },

    data: function data() {
        return {
            loading: false,
            contentReady: false
        };
    },
    created: function created() {
        var _this = this;

        this.comment.content = '';

        Event.$on('teacher-detail-was-closed', function () {
            _this.contentReady = false;
        });
    },


    methods: {
        title: function title() {

            var content = this.comment.comment_content;
            var m = content.match(/<strong>(.*?)<\/strong>/i);
            content = (m !== null ? m[1] : content).replace(/(\(|（).*(\)|）)/g, '');

            return content;
        },
        link: function link() {
            return '/?p=' + this.postId();
        },
        postId: function postId() {
            var m = this.comment.comment_author_url.match(/(\d+).php/i);
            if (m === null) {
                return;
            }

            return m[1];
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n\n<div>\n    <i class=\"student\"></i>\n    <a :href=\"link()\" target=\"_blank\">\n        {{ title() }}\n        <i class=\"share\"></i>\n    </a>\n</div>\n\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7fcfcdfb", module.exports)
  } else {
    hotAPI.update("_v-7fcfcdfb", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./../plugins/wordpress-posts/PostCollection":23,"./Teacher":8,"vue":31,"vue-hot-reload-api":30}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            visible: false,
            message: ''
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('show-message', function (message) {
            _this.visible = true;
            _this.message = message;

            setTimeout(function () {
                _this.visible = false;
            }, 5000);
        });

        Event.$on('hide-message', function () {
            _this.visible = false;
        });
    },
    mounted: function mounted() {},


    methods: {
        onClick: function onClick(station) {
            Event.$emit('loading');
            Event.$emit('station-was-selected', station.term_taxonomy_id);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<transition name=\"slide-fade--up\">\n    <div class=\"message-pop\" v-show=\"visible\">\n        <div class=\"message-pop__inner\" v-html=\"message\">\n        </div>\n    </div>\n</transition>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1ef02790", module.exports)
  } else {
    hotAPI.update("_v-1ef02790", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"vue":31,"vue-hot-reload-api":30}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Stations = require('./Stations');

var _Stations2 = _interopRequireDefault(_Stations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    props: {},

    computed: {},

    data: function data() {
        return {
            popular_stations: _Stations2.default.popularStations
        };
    },
    created: function created() {},
    mounted: function mounted() {},


    methods: {
        onClick: function onClick(station) {
            Event.$emit('loading');
            Event.$emit('station-was-selected', station.term_taxonomy_id);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"popular-stations\">\n    <ul>\n        <li>人気のある駅：</li>\n        <li v-for=\"station in popular_stations\">\n            <a :id=\"'gtm-station--popular-tag-'+station.term_taxonomy_id\" :title=\"station.name\" href=\"#\" @click.prevent=\"onClick(station)\">\n                {{ station.name }}\n            </a>\n        </li>\n    </ul>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7686cb8c", module.exports)
  } else {
    hotAPI.update("_v-7686cb8c", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"./Stations":7,"vue":31,"vue-hot-reload-api":30}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Stations = require('./Stations');

var _Stations2 = _interopRequireDefault(_Stations);

var _URLUtil = require('../utils/URLUtil');

var _URLUtil2 = _interopRequireDefault(_URLUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    props: {},

    computed: {
        filtered: function filtered() {
            var _this = this;

            return this.routeInputValue === '' ? this.routes : this.routes.filter(function (route) {
                return _this.exists(_this.routeInputValue, route);
            });
        }
    },

    data: function data() {
        return {
            routes: _Stations2.default.routes,
            dropMenuShown: false,
            routeInputValue: '',
            currentSelectPosition: -1
        };
    },
    created: function created() {},
    mounted: function mounted() {
        var route = _URLUtil2.default.get_query('route', false);

        if (route) {
            this.submit(route);
        }
    },


    methods: {
        showDropMenu: function showDropMenu() {
            var scroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;


            //                if (this.filtered.length === 0) {return; }

            this.dropMenuShown = true;

            if (!scroll) {
                return;
            }

            $('html,body').animate({
                scrollTop: $('#rosen').offset().top
            }, 'fast');

            if (this.routeInputValue !== '') {
                document.getElementById("rosen-input").select();
            }
        },
        hideDropMenu: function hideDropMenu() {
            this.dropMenuShown = false;
        },
        exists: function exists(needle, haystack) {
            return haystack.indexOf(needle) !== -1;
        },
        submit: function submit() {
            var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            if (route === '' && this.filtered.length === 1) {
                route = this.filtered.pop();
            }

            // カーソルで選んでEnterをクリックしたケース
            if (route === '' && this.currentSelectPosition > -1) {
                route = this.filtered[this.currentSelectPosition];
            }

            Event.$emit('route-was-changed', route);
            this.routeInputValue = route;
            this.hideDropMenu();

            $('#rosen-input').blur();
        },
        move: function move(add) {
            this.showDropMenu(false);

            if (this.currentSelectPosition + add <= -1 // 最上部より上のとき
            || this.currentSelectPosition > this.filtered.length) {
                // 収まってないとき
                this.currentSelectPosition = 0;
                return;
            }

            if (this.currentSelectPosition + add >= this.filtered.length) {
                // 収まらないとき
                this.currentSelectPosition = this.filtered.length - 1;
                return;
            }

            this.currentSelectPosition += add;
        },
        hoverStyle: function hoverStyle(idx) {
            return this.currentSelectPosition === idx ? 'hovered' : '';
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<fieldset class=\"teacher-search__route-input teacher-search__element\">\n    <legend class=\"teacher-search__title\">\n        1.路線を選択してください\n    </legend>\n\n    <div id=\"rosen\" class=\"teacher-search__route-input-group\">\n        <input id=\"rosen-input\" type=\"text\" class=\"teacher-search__input form-control\" placeholder=\"例：京浜急行線\" v-model=\"routeInputValue\" @focus=\"showDropMenu\" @click=\"showDropMenu\" @keyup.prevent.38=\"move(-1)\" @keyup.prevent.40=\"move(1)\">\n        <div class=\"teacher-search__cover\"></div>\n        <ul id=\"rosen-list\" class=\"dropdown-menu teacher-search__dropdown\" v-show=\"dropMenuShown\">\n            <li v-for=\"(route,idx) in filtered\">\n                <a :id=\"'gtm-rosen--' + idx\" href=\"#\" @click.prevent=\"submit(route)\" :class=\"hoverStyle(idx)\">\n                    {{ route }}\n                </a>\n            </li>\n        </ul>\n\n    </div>\n\n</fieldset>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-0e8b4aef", module.exports)
  } else {
    hotAPI.update("_v-0e8b4aef", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../utils/URLUtil":27,"./Stations":7,"vue":31,"vue-hot-reload-api":30}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MyForm = require('../plugins/MyForm');

var _MyForm2 = _interopRequireDefault(_MyForm);

var _Stations = require('./Stations');

var _Stations2 = _interopRequireDefault(_Stations);

var _GetTeachers = require('../jobs/GetTeachers');

var _GetTeachers2 = _interopRequireDefault(_GetTeachers);

var _Cache = require('../plugins/Cache');

var _Cache2 = _interopRequireDefault(_Cache);

var _TypeUtil = require('../utils/TypeUtil');

var _TypeUtil2 = _interopRequireDefault(_TypeUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    computed: {
        routeWasSelected: function routeWasSelected() {
            return this.route !== '';
        },
        filtered: function filtered() {
            return this.routeWasSelected ? this.stations[this.route] : [];
        }
    },

    data: function data() {
        return {
            form: new _MyForm2.default({
                term_taxonomy_ids: []
            }),
            stations: _Stations2.default.json,
            route: '',
            searched: false,

            getTeachersJob: new _GetTeachers2.default(this)
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('route-was-changed', function (route) {
            _this.route = route;
            _this.form.reset();
            _this.form.term_taxonomy_ids = _this.stations[route].map(function (station) {
                return station.term_taxonomy_id;
            });
            _this.onChanged();
        });
        Event.$on('station-was-selected', function (station_term_taxonomy_ids) {
            var save_history = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            _this.form.term_taxonomy_ids = _TypeUtil2.default.typeOfArray(station_term_taxonomy_ids) ? station_term_taxonomy_ids : [station_term_taxonomy_ids];

            _this.submit(save_history);
        });
    },
    mounted: function mounted() {},


    methods: {
        submit: function submit() {
            var save_history = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            Event.$emit('loading');

            var station_ids = this.form.term_taxonomy_ids.join(',');

            _Cache2.default.set('last', 'stations', station_ids);

            if (save_history) {
                history.pushState(null, '', '/teachers/?tt=' + station_ids);
            }

            this.getTeachersJob.handle();
        },
        checkAll: function checkAll() {
            var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;


            if (!on) {
                this.form.term_taxonomy_ids = [];
                return;
            }

            this.form.term_taxonomy_ids = this.stations[this.route].map(function (station) {
                return station.term_taxonomy_id;
            });

            this.onChanged();
        },
        onChanged: function onChanged() {
            this.searched = false;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<fieldset v-show=\"routeWasSelected\" class=\"teacher-search__station-checks teacher-search__element\">\n    <legend class=\"teacher-search__title\">\n        2.レッスン希望駅を選択してください\n    </legend>\n\n    <div class=\"btn-group teacher-search__btn-group\">\n        <a href=\"#\" class=\"btn btn-orange\" @click.prevent=\"checkAll(true)\">\n            すべてON\n        </a>\n        <a href=\"#\" class=\"btn btn-orange\" @click.prevent=\"checkAll(false)\">\n            すべてOFF\n        </a>\n    </div>\n\n    <ul class=\"teacher-search__list\">\n        <li v-for=\"station in filtered\">\n            <div class=\"teacher-search__checkbox\">\n                <input type=\"checkbox\" :id=\"'station-'+station.term_taxonomy_id\" :value=\"station.term_taxonomy_id\" v-model=\"form.term_taxonomy_ids\">\n                <label :for=\"'station-'+station.term_taxonomy_id\" @click=\"onChanged\">\n                    <i class=\"checked check--white\"></i>\n                    <i class=\"unchecked\">□</i>\n                    {{ station.name }}\n                    <span v-show=\"station.popular\" class=\"teacher-search__label-after\">人気♪</span>\n                </label>\n            </div>\n        </li>\n    </ul>\n\n    <transition name=\"slide-fade--up\">\n        <a id=\"gtm-station--submit-button\" href=\"#\" class=\"teacher-search__submit-btn\" @click.prevent=\"submit\" v-show=\"!searched &amp;&amp; routeWasSelected\" title=\"ご指定の駅で検索\">\n            <i class=\"search\"></i> 講師を検索する\n        </a>\n    </transition>\n</fieldset>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-31e2239a", module.exports)
  } else {
    hotAPI.update("_v-31e2239a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../jobs/GetTeachers":12,"../plugins/Cache":13,"../plugins/MyForm":19,"../utils/TypeUtil":26,"./Stations":7,"vue":31,"vue-hot-reload-api":30}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
            value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ObjectUtil = require('../utils/ObjectUtil');

var _ObjectUtil2 = _interopRequireDefault(_ObjectUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Stations = function () {
            function Stations() {
                        _classCallCheck(this, Stations);
            }

            _createClass(Stations, null, [{
                        key: 'allStations',
                        value: function allStations() {

                                    var exists = [];
                                    var unique = [];

                                    for (var route in this.json) {
                                                if (!this.json.hasOwnProperty(route)) {
                                                            continue;
                                                }
                                                var stations = this.json[route];

                                                var _loop = function _loop(sidx) {
                                                            if (!stations.hasOwnProperty(sidx)) {
                                                                        return 'continue';
                                                            }
                                                            var station = stations[sidx];

                                                            if (exists.some(function (exist_station_id) {
                                                                        return station.term_taxonomy_id === exist_station_id;
                                                            })) {
                                                                        return 'continue';
                                                            }

                                                            unique.push(station);
                                                            exists.push(station.term_taxonomy_id);
                                                };

                                                for (var sidx in stations) {
                                                            var _ret = _loop(sidx);

                                                            if (_ret === 'continue') continue;
                                                }
                                    }

                                    return unique;
                        }
            }, {
                        key: 'station',
                        value: function station(term_taxonomy_id) {
                                    var allStations = this.allStations();

                                    for (var idx in allStations) {
                                                if (!allStations.hasOwnProperty(idx)) {
                                                            continue;
                                                }
                                                var _station = allStations[idx];
                                                if (_station.term_taxonomy_id === parseInt(term_taxonomy_id)) {
                                                            return _station;
                                                }
                                    }

                                    return null;
                        }
            }, {
                        key: 'stations',
                        value: function stations(route) {
                                    return this.json[route];
                        }
            }, {
                        key: 'json',


                        // ここの並びを変えると画面にも反映される
                        get: function get() {
                                    return {
                                                オンライン: [{ name: 'オンライン', term_taxonomy_id: 5706, popular: true }],
                                                JR山手線: [{ name: '品川駅', term_taxonomy_id: 42, popular: false }, { name: '大崎駅', term_taxonomy_id: 5354, popular: false }, { name: '五反田駅', term_taxonomy_id: 5029, popular: false }, { name: '目黒駅', term_taxonomy_id: 5013, popular: false }, { name: '恵比寿駅', term_taxonomy_id: 83, popular: false }, { name: '渋谷駅', term_taxonomy_id: 29, popular: true }, { name: '原宿駅', term_taxonomy_id: 5121, popular: false }, { name: '代々木駅', term_taxonomy_id: 5028, popular: false }, { name: '新宿駅', term_taxonomy_id: 18, popular: false }, { name: '新大久保駅', term_taxonomy_id: 5321, popular: false }, { name: '高田馬場駅', term_taxonomy_id: 19, popular: false }, { name: '目白駅', term_taxonomy_id: 5322, popular: false }, { name: '池袋駅', term_taxonomy_id: 32, popular: false }, { name: '大塚駅', term_taxonomy_id: 5323, popular: false }, { name: '巣鴨駅', term_taxonomy_id: 5324, popular: false }, { name: '駒込駅', term_taxonomy_id: 5291, popular: false }, { name: '田端駅', term_taxonomy_id: 5052, popular: false }, { name: '西日暮里駅', term_taxonomy_id: 5027, popular: false }, { name: '日暮里駅', term_taxonomy_id: 5016, popular: false }, { name: '鶯谷駅', term_taxonomy_id: 5227, popular: false }, { name: '上野駅', term_taxonomy_id: 48, popular: false }, { name: '御徒町駅', term_taxonomy_id: 5158, popular: false }, { name: '秋葉原駅', term_taxonomy_id: 91, popular: false }, { name: '神田駅', term_taxonomy_id: 5325, popular: false }, { name: '東京駅', term_taxonomy_id: 5046, popular: false }, { name: '有楽町駅', term_taxonomy_id: 5108, popular: false }, { name: '新橋駅', term_taxonomy_id: 96, popular: false }, { name: '浜松町駅', term_taxonomy_id: 5326, popular: false }, { name: '田町駅', term_taxonomy_id: 41, popular: false }],
                                                JR京浜東北線: [{ name: '大宮駅', term_taxonomy_id: 54, popular: false }, { name: 'さいたま新都心駅', term_taxonomy_id: 5162, popular: false }, { name: '与野駅', term_taxonomy_id: 5415, popular: false }, { name: '北浦和駅', term_taxonomy_id: 5416, popular: false }, { name: '浦和駅', term_taxonomy_id: 5417, popular: false }, { name: '南浦和駅', term_taxonomy_id: 5352, popular: false }, { name: '蕨駅', term_taxonomy_id: 5353, popular: false }, { name: '西川口駅', term_taxonomy_id: 5288, popular: false }, { name: '川口駅', term_taxonomy_id: 5418, popular: false }, { name: '赤羽駅', term_taxonomy_id: 5024, popular: false }, { name: '東十条駅', term_taxonomy_id: 5419, popular: false }, { name: '王子駅', term_taxonomy_id: 5287, popular: false }, { name: '上中里駅', term_taxonomy_id: 5420, popular: false }, { name: '田端駅', term_taxonomy_id: 5052, popular: false }, { name: '西日暮里駅', term_taxonomy_id: 5027, popular: false }, { name: '日暮里駅', term_taxonomy_id: 5016, popular: false }, { name: '鶯谷駅', term_taxonomy_id: 5227, popular: false }, { name: '上野駅', term_taxonomy_id: 48, popular: false }, { name: '御徒町駅', term_taxonomy_id: 5158, popular: false }, { name: '秋葉原駅', term_taxonomy_id: 91, popular: false }, { name: '神田駅', term_taxonomy_id: 5325, popular: false }, { name: '東京駅', term_taxonomy_id: 5046, popular: false }, { name: '有楽町駅', term_taxonomy_id: 5108, popular: false }, { name: '新橋駅', term_taxonomy_id: 96, popular: false }, { name: '浜松町駅', term_taxonomy_id: 5326, popular: false }, { name: '田町駅', term_taxonomy_id: 41, popular: false }, { name: '品川駅', term_taxonomy_id: 42, popular: false }, { name: '大井町駅', term_taxonomy_id: 84, popular: false }, { name: '大森駅', term_taxonomy_id: 82, popular: false }, { name: '蒲田駅', term_taxonomy_id: 37, popular: true }, { name: '川崎駅', term_taxonomy_id: 52, popular: false }, { name: '鶴見駅', term_taxonomy_id: 5327, popular: false }, { name: '新子安駅', term_taxonomy_id: 5328, popular: false }, { name: '東神奈川駅', term_taxonomy_id: 5329, popular: false }, { name: '横浜駅', term_taxonomy_id: 16, popular: true }],
                                                JR中央線: [{ name: '東京駅', term_taxonomy_id: 5046, popular: false }, { name: '神田駅', term_taxonomy_id: 5325, popular: false }, { name: '御茶ノ水駅', term_taxonomy_id: 5026, popular: false }, { name: '水道橋駅', term_taxonomy_id: 5347, popular: false }, { name: '飯田橋駅', term_taxonomy_id: 101, popular: false }, { name: '市ヶ谷駅', term_taxonomy_id: 5140, popular: false }, { name: '四ツ谷駅', term_taxonomy_id: 5014, popular: false }, { name: '信濃町駅', term_taxonomy_id: 5423, popular: false }, { name: '千駄ヶ谷駅', term_taxonomy_id: 5424, popular: false }, { name: '代々木駅', term_taxonomy_id: 5028, popular: false }, { name: '新宿駅', term_taxonomy_id: 18, popular: false }, { name: '大久保駅', term_taxonomy_id: 5425, popular: false }, { name: '東中野駅', term_taxonomy_id: 5218, popular: false }, { name: '中野駅', term_taxonomy_id: 5012, popular: false }, { name: '高円寺駅', term_taxonomy_id: 5348, popular: false }, { name: '阿佐ヶ谷駅', term_taxonomy_id: 5174, popular: false }, { name: '荻窪駅', term_taxonomy_id: 89, popular: false }, { name: '西荻窪駅', term_taxonomy_id: 5349, popular: false }, { name: '吉祥寺駅', term_taxonomy_id: 30, popular: false }, { name: '三鷹駅', term_taxonomy_id: 5176, popular: false }, { name: '武蔵境駅', term_taxonomy_id: 5298, popular: false }, { name: '東小金井駅', term_taxonomy_id: 5297, popular: false }, { name: '武蔵小金井駅', term_taxonomy_id: 5296, popular: false }, { name: '国分寺駅', term_taxonomy_id: 5138, popular: false }, { name: '西国分寺駅', term_taxonomy_id: 5295, popular: false }, { name: '国立駅', term_taxonomy_id: 21, popular: false }, { name: '立川駅', term_taxonomy_id: 80, popular: false }, { name: '日野駅', term_taxonomy_id: 5294, popular: false }, { name: '豊田駅', term_taxonomy_id: 5293, popular: false }, { name: '八王子駅', term_taxonomy_id: 56, popular: false }],
                                                JR横須賀線: [{ name: '東京駅', term_taxonomy_id: 5046, popular: false }, { name: '新橋駅', term_taxonomy_id: 96, popular: false }, { name: '品川駅', term_taxonomy_id: 42, popular: false }, { name: '西大井駅', term_taxonomy_id: 5187, popular: false }, { name: '武蔵小杉駅', term_taxonomy_id: 55, popular: true }, { name: '新川崎駅', term_taxonomy_id: 5186, popular: false }, { name: '横浜駅', term_taxonomy_id: 16, popular: true }, { name: '保土ヶ谷駅', term_taxonomy_id: 5185, popular: false }, { name: '東戸塚駅', term_taxonomy_id: 5184, popular: false }, { name: '戸塚駅', term_taxonomy_id: 5119, popular: false }, { name: '大船駅', term_taxonomy_id: 114, popular: false }, { name: '北鎌倉駅', term_taxonomy_id: 5426, popular: false }, { name: '鎌倉駅', term_taxonomy_id: 5159, popular: false }, { name: '逗子駅', term_taxonomy_id: 115, popular: false }, { name: '東逗子駅', term_taxonomy_id: 5427, popular: false }, { name: '田浦駅', term_taxonomy_id: 5428, popular: false }, { name: '横須賀駅', term_taxonomy_id: 49, popular: false }, { name: '衣笠駅', term_taxonomy_id: 5429, popular: false }, { name: '久里浜駅', term_taxonomy_id: 5331, popular: false }],
                                                JR東海道線: [{ name: '東京駅', term_taxonomy_id: 5046, popular: false }, { name: '新橋駅', term_taxonomy_id: 96, popular: false }, { name: '品川駅', term_taxonomy_id: 42, popular: false }, { name: '川崎駅', term_taxonomy_id: 52, popular: false }, { name: '横浜駅', term_taxonomy_id: 16, popular: true }, { name: '戸塚駅', term_taxonomy_id: 5119, popular: false }, { name: '大船駅', term_taxonomy_id: 114, popular: false }, { name: '藤沢駅', term_taxonomy_id: 77, popular: false }, { name: '辻堂駅', term_taxonomy_id: 5181, popular: false }, { name: '茅ヶ崎駅', term_taxonomy_id: 5021, popular: false }, { name: '平塚駅', term_taxonomy_id: 5022, popular: false }, { name: '大磯駅', term_taxonomy_id: 5430, popular: false }, { name: '二宮駅', term_taxonomy_id: 5431, popular: false }, { name: '国府津駅', term_taxonomy_id: 5432, popular: false }, { name: '鴨宮駅', term_taxonomy_id: 5433, popular: false }, { name: '小田原駅', term_taxonomy_id: 5023, popular: false }],
                                                JR横浜線: [{ name: '東神奈川駅', term_taxonomy_id: 5329, popular: false }, { name: '大口駅', term_taxonomy_id: 5337, popular: false }, { name: '菊名駅', term_taxonomy_id: 5139, popular: false }, { name: '新横浜駅', term_taxonomy_id: 5125, popular: false }, { name: '小机駅', term_taxonomy_id: 5247, popular: false }, { name: '鴨居駅', term_taxonomy_id: 5246, popular: false }, { name: '中山駅', term_taxonomy_id: 5434, popular: false }, { name: '十日市場駅', term_taxonomy_id: 5435, popular: false }, { name: '長津田駅', term_taxonomy_id: 5335, popular: false }, { name: '成瀬駅', term_taxonomy_id: 5436, popular: false }, { name: '町田駅', term_taxonomy_id: 47, popular: false }, { name: '古淵駅', term_taxonomy_id: 5437, popular: false }, { name: '淵野辺駅', term_taxonomy_id: 5438, popular: false }, { name: '矢部駅', term_taxonomy_id: 5439, popular: false }, { name: '相模原駅', term_taxonomy_id: 5338, popular: false }, { name: '橋本駅', term_taxonomy_id: 5011, popular: false }, { name: '相原駅', term_taxonomy_id: 5440, popular: false }, { name: '八王子みなみ野駅', term_taxonomy_id: 5441, popular: false }, { name: '片倉駅', term_taxonomy_id: 5442, popular: false }, { name: '八王子駅', term_taxonomy_id: 56, popular: false }],
                                                JR根岸線: [{ name: '横浜駅', term_taxonomy_id: 16, popular: true }, { name: '桜木町駅', term_taxonomy_id: 107, popular: false }, { name: '関内駅', term_taxonomy_id: 5398, popular: false }, { name: '石川町駅', term_taxonomy_id: 5422, popular: false }, { name: '山手駅', term_taxonomy_id: 5443, popular: false }, { name: '根岸駅', term_taxonomy_id: 5444, popular: false }, { name: '磯子駅', term_taxonomy_id: 5445, popular: false }, { name: '新杉田駅', term_taxonomy_id: 5446, popular: false }, { name: '洋光台駅', term_taxonomy_id: 5330, popular: false }, { name: '港南台駅', term_taxonomy_id: 5447, popular: false }, { name: '本郷台駅', term_taxonomy_id: 5448, popular: false }, { name: '大船駅', term_taxonomy_id: 114, popular: false }],
                                                JR南武線: [{ name: '川崎駅', term_taxonomy_id: 52, popular: false }, { name: '尻手駅', term_taxonomy_id: 5449, popular: false }, { name: '矢向駅', term_taxonomy_id: 5450, popular: false }, { name: '鹿島田駅', term_taxonomy_id: 5451, popular: false }, { name: '平間駅', term_taxonomy_id: 5452, popular: false }, { name: '向河原駅', term_taxonomy_id: 5453, popular: false }, { name: '武蔵小杉駅', term_taxonomy_id: 55, popular: true }, { name: '武蔵中原駅', term_taxonomy_id: 5250, popular: false }, { name: '武蔵新城駅', term_taxonomy_id: 5454, popular: false }, { name: '武蔵溝ノ口駅', term_taxonomy_id: 5455, popular: false }, { name: '津田山駅', term_taxonomy_id: 5456, popular: false }, { name: '久地駅', term_taxonomy_id: 5457, popular: false }, { name: '宿河原駅', term_taxonomy_id: 5458, popular: false }, { name: '登戸駅', term_taxonomy_id: 5059, popular: false }, { name: '中野島駅', term_taxonomy_id: 5459, popular: false }, { name: '稲田堤駅', term_taxonomy_id: 5057, popular: false }, { name: '矢野口駅', term_taxonomy_id: 5460, popular: false }, { name: '稲城長沼駅', term_taxonomy_id: 5461, popular: false }, { name: '南多摩駅', term_taxonomy_id: 5462, popular: false }, { name: '府中本町駅', term_taxonomy_id: 5058, popular: false }, { name: '分倍河原駅', term_taxonomy_id: 5056, popular: false }, { name: '西府駅', term_taxonomy_id: 5463, popular: false }, { name: '谷保駅', term_taxonomy_id: 5464, popular: false }, { name: '矢川駅', term_taxonomy_id: 5465, popular: false }, { name: '西国立駅', term_taxonomy_id: 5466, popular: false }, { name: '立川駅', term_taxonomy_id: 80, popular: false }],
                                                JR常磐線: [{ name: '上野駅', term_taxonomy_id: 48, popular: false }, { name: '日暮里駅', term_taxonomy_id: 5016, popular: false }, { name: '三河島駅', term_taxonomy_id: 5467, popular: false }, { name: '南千住駅', term_taxonomy_id: 5468, popular: false }, { name: '北千住駅', term_taxonomy_id: 39, popular: true }, { name: '綾瀬駅', term_taxonomy_id: 5226, popular: false }, { name: '亀有駅', term_taxonomy_id: 5251, popular: false }, { name: '金町駅', term_taxonomy_id: 5252, popular: false }, { name: '松戸駅', term_taxonomy_id: 109, popular: false }, { name: '北松戸駅', term_taxonomy_id: 5233, popular: false }, { name: '馬橋駅', term_taxonomy_id: 5234, popular: false }, { name: '新松戸駅', term_taxonomy_id: 5235, popular: false }, { name: '北小金駅', term_taxonomy_id: 5236, popular: false }, { name: '南柏駅', term_taxonomy_id: 5237, popular: false }, { name: '柏駅', term_taxonomy_id: 76, popular: false }, { name: '北柏駅', term_taxonomy_id: 5238, popular: false }, { name: '我孫子駅', term_taxonomy_id: 108, popular: false }, { name: '天王台駅', term_taxonomy_id: 5469, popular: false }, { name: '取手駅', term_taxonomy_id: 5470, popular: false }],
                                                JR総武線: [{ name: '御茶ノ水駅', term_taxonomy_id: 5026, popular: false }, { name: '秋葉原駅', term_taxonomy_id: 91, popular: false }, { name: '浅草橋駅', term_taxonomy_id: 5156, popular: false }, { name: '両国駅', term_taxonomy_id: 5471, popular: false }, { name: '錦糸町駅', term_taxonomy_id: 53, popular: false }, { name: '亀戸駅', term_taxonomy_id: 5472, popular: false }, { name: '平井駅', term_taxonomy_id: 5473, popular: false }, { name: '新小岩駅', term_taxonomy_id: 5474, popular: false }, { name: '小岩駅', term_taxonomy_id: 5025, popular: false }, { name: '市川駅', term_taxonomy_id: 5150, popular: false }, { name: '本八幡駅', term_taxonomy_id: 5475, popular: false }, { name: '下総中山駅', term_taxonomy_id: 5476, popular: false }, { name: '西船橋駅', term_taxonomy_id: 24, popular: false }, { name: '船橋駅', term_taxonomy_id: 93, popular: false }, { name: '東船橋駅', term_taxonomy_id: 5477, popular: false }, { name: '津田沼駅', term_taxonomy_id: 40, popular: false }, { name: '幕張本郷駅', term_taxonomy_id: 5478, popular: false }, { name: '幕張駅', term_taxonomy_id: 5479, popular: false }, { name: '新検見川駅', term_taxonomy_id: 5480, popular: false }, { name: '稲毛駅', term_taxonomy_id: 104, popular: false }, { name: '西千葉駅', term_taxonomy_id: 5481, popular: false }, { name: '千葉駅', term_taxonomy_id: 58, popular: false }, { name: '東千葉駅', term_taxonomy_id: 5482, popular: false }, { name: '都賀駅', term_taxonomy_id: 33, popular: false }],
                                                JR京葉線: [{ name: '東京駅', term_taxonomy_id: 5046, popular: false }, { name: '八丁堀駅', term_taxonomy_id: 5008, popular: false }, { name: '越中島駅', term_taxonomy_id: 5483, popular: false }, { name: '潮見駅', term_taxonomy_id: 5484, popular: false }, { name: '新木場駅', term_taxonomy_id: 5190, popular: false }, { name: '葛西臨海公園駅', term_taxonomy_id: 5485, popular: false }, { name: '舞浜駅', term_taxonomy_id: 5272, popular: false }, { name: '新浦安駅', term_taxonomy_id: 105, popular: false }, { name: '市川塩浜駅', term_taxonomy_id: 5273, popular: false }, { name: '二俣新町駅', term_taxonomy_id: 5486, popular: false }, { name: '南船橋駅', term_taxonomy_id: 5487, popular: false }, { name: '新習志野駅', term_taxonomy_id: 5489, popular: false }, { name: '海浜幕張駅', term_taxonomy_id: 103, popular: false }, { name: '検見川浜駅', term_taxonomy_id: 5276, popular: false }, { name: '稲毛海岸駅', term_taxonomy_id: 5277, popular: false }, { name: '千葉みなと駅', term_taxonomy_id: 5278, popular: false }, { name: '蘇我駅', term_taxonomy_id: 5146, popular: false }],
                                                JR埼京線: [{ name: '大崎駅', term_taxonomy_id: 5354, popular: false }, { name: '恵比寿駅', term_taxonomy_id: 83, popular: false }, { name: '渋谷駅', term_taxonomy_id: 29, popular: true }, { name: '新宿駅', term_taxonomy_id: 18, popular: false }, { name: '池袋駅', term_taxonomy_id: 32, popular: false }, { name: '板橋駅', term_taxonomy_id: 5490, popular: false }, { name: '十条駅', term_taxonomy_id: 5491, popular: false }, { name: '赤羽駅', term_taxonomy_id: 5024, popular: false }, { name: '北赤羽駅', term_taxonomy_id: 5492, popular: false }, { name: '浮間舟渡駅', term_taxonomy_id: 5493, popular: false }, { name: '戸田公園駅', term_taxonomy_id: 5494, popular: false }, { name: '戸田駅', term_taxonomy_id: 5495, popular: false }, { name: '北戸田駅', term_taxonomy_id: 5496, popular: false }, { name: '武蔵浦和駅', term_taxonomy_id: 90, popular: false }, { name: '中浦和駅', term_taxonomy_id: 5497, popular: false }, { name: '南与野駅', term_taxonomy_id: 5498, popular: false }, { name: '与野本町駅', term_taxonomy_id: 5499, popular: false }, { name: '北与野駅', term_taxonomy_id: 5500, popular: false }, { name: '大宮駅', term_taxonomy_id: 54, popular: false }],
                                                JR青梅線: [{ name: '立川駅', term_taxonomy_id: 80, popular: false }, { name: '西立川駅', term_taxonomy_id: 5501, popular: false }, { name: '東中神駅', term_taxonomy_id: 5502, popular: false }, { name: '中神駅', term_taxonomy_id: 5503, popular: false }, { name: '昭島駅', term_taxonomy_id: 5504, popular: false }, { name: '拝島駅', term_taxonomy_id: 5017, popular: false }, { name: '牛浜駅', term_taxonomy_id: 5505, popular: false }, { name: '福生駅', term_taxonomy_id: 5018, popular: false }, { name: '羽村駅', term_taxonomy_id: 5506, popular: false }, { name: '小作駅', term_taxonomy_id: 5507, popular: false }, { name: '河辺駅', term_taxonomy_id: 5508, popular: false }, { name: '東青梅駅', term_taxonomy_id: 5509, popular: false }, { name: '青梅駅', term_taxonomy_id: 5019, popular: false }],
                                                JR相模線: [{ name: '茅ヶ崎駅', term_taxonomy_id: 5021, popular: false }, { name: '北茅ヶ崎駅', term_taxonomy_id: 5510, popular: false }, { name: '香川駅', term_taxonomy_id: 5511, popular: false }, { name: '寒川駅', term_taxonomy_id: 5512, popular: false }, { name: '宮山駅', term_taxonomy_id: 5513, popular: false }, { name: '倉見駅', term_taxonomy_id: 5514, popular: false }, { name: '門沢橋駅', term_taxonomy_id: 5515, popular: false }, { name: '社家駅', term_taxonomy_id: 5516, popular: false }, { name: '厚木駅', term_taxonomy_id: 5517, popular: false }, { name: '海老名駅', term_taxonomy_id: 88, popular: false }, { name: '入谷駅', term_taxonomy_id: 5518, popular: false }, { name: '相武台下駅', term_taxonomy_id: 5519, popular: false }, { name: '下溝駅', term_taxonomy_id: 5520, popular: false }, { name: '原当麻駅', term_taxonomy_id: 5132, popular: false }, { name: '番田駅', term_taxonomy_id: 5521, popular: false }, { name: '上溝駅', term_taxonomy_id: 5522, popular: false }, { name: '南橋本駅', term_taxonomy_id: 5523, popular: false }, { name: '橋本駅', term_taxonomy_id: 5011, popular: false }],
                                                JR武蔵野線: [{ name: '府中本町駅', term_taxonomy_id: 5058, popular: false }, { name: '北府中駅', term_taxonomy_id: 5524, popular: false }, { name: '西国分寺駅', term_taxonomy_id: 5295, popular: false }, { name: '新小平駅', term_taxonomy_id: 5525, popular: false }, { name: '新秋津駅', term_taxonomy_id: 5526, popular: false }, { name: '東所沢駅', term_taxonomy_id: 5527, popular: false }, { name: '新座駅', term_taxonomy_id: 5528, popular: false }, { name: '北朝霞駅', term_taxonomy_id: 5529, popular: false }, { name: '西浦和駅', term_taxonomy_id: 5530, popular: false }, { name: '武蔵浦和駅', term_taxonomy_id: 90, popular: false }, { name: '南浦和駅', term_taxonomy_id: 5352, popular: false }, { name: '東浦和駅', term_taxonomy_id: 5313, popular: false }, { name: '東川口駅', term_taxonomy_id: 5311, popular: false }, { name: '南越谷駅', term_taxonomy_id: 5312, popular: false }, { name: '越谷レイクタウン駅', term_taxonomy_id: 5310, popular: false }, { name: '吉川駅', term_taxonomy_id: 5531, popular: false }, { name: '吉川美南駅', term_taxonomy_id: 5532, popular: false }, { name: '新三郷駅', term_taxonomy_id: 5533, popular: false }, { name: '三郷駅', term_taxonomy_id: 5255, popular: false }, { name: '南流山駅', term_taxonomy_id: 5254, popular: false }, { name: '新松戸駅', term_taxonomy_id: 5235, popular: false }, { name: '新八柱駅', term_taxonomy_id: 5534, popular: false }, { name: '東松戸駅', term_taxonomy_id: 5535, popular: false }, { name: '市川大野駅', term_taxonomy_id: 5536, popular: false }, { name: '船橋法典駅', term_taxonomy_id: 5537, popular: false }, { name: '西船橋駅', term_taxonomy_id: 24, popular: false }, { name: '南船橋駅', term_taxonomy_id: 5487, popular: false }],
                                                東京メトロ銀座線: [{ name: '浅草駅', term_taxonomy_id: 5351, popular: false }, { name: '田原町駅', term_taxonomy_id: 5538, popular: false }, { name: '稲荷町駅', term_taxonomy_id: 5539, popular: false }, { name: '上野駅', term_taxonomy_id: 48, popular: false }, { name: '上野広小路駅', term_taxonomy_id: 5540, popular: false }, { name: '末広町駅', term_taxonomy_id: 5541, popular: false }, { name: '神田駅', term_taxonomy_id: 5325, popular: false }, { name: '三越前駅', term_taxonomy_id: 5292, popular: false }, { name: '日本橋駅', term_taxonomy_id: 5007, popular: false }, { name: '京橋駅', term_taxonomy_id: 5542, popular: false }, { name: '銀座駅', term_taxonomy_id: 5045, popular: false }, { name: '新橋駅', term_taxonomy_id: 96, popular: false }, { name: '虎ノ門駅', term_taxonomy_id: 5204, popular: false }, { name: '溜池山王駅', term_taxonomy_id: 5015, popular: false }, { name: '赤坂見附駅', term_taxonomy_id: 5154, popular: false }, { name: '青山一丁目駅', term_taxonomy_id: 5201, popular: false }, { name: '外苑前駅', term_taxonomy_id: 5543, popular: false }, { name: '表参道駅', term_taxonomy_id: 100, popular: false }, { name: '渋谷駅', term_taxonomy_id: 29, popular: true }],
                                                東京メトロ半蔵門線: [{ name: '渋谷駅', term_taxonomy_id: 29, popular: true }, { name: '表参道駅', term_taxonomy_id: 100, popular: false }, { name: '青山一丁目駅', term_taxonomy_id: 5201, popular: false }, { name: '永田町駅', term_taxonomy_id: 5197, popular: false }, { name: '半蔵門駅', term_taxonomy_id: 35, popular: false }, { name: '九段下駅', term_taxonomy_id: 102, popular: false }, { name: '神保町駅', term_taxonomy_id: 5546, popular: false }, { name: '大手町駅', term_taxonomy_id: 27, popular: false }, { name: '三越前駅', term_taxonomy_id: 5292, popular: false }, { name: '水天宮前駅', term_taxonomy_id: 5545, popular: false }, { name: '清澄白河駅', term_taxonomy_id: 110, popular: false }, { name: '住吉駅', term_taxonomy_id: 5544, popular: false }, { name: '錦糸町駅', term_taxonomy_id: 53, popular: false }, { name: '押上駅', term_taxonomy_id: 46, popular: false }],
                                                東京メトロ日比谷線: [{ name: '北千住駅', term_taxonomy_id: 39, popular: true }, { name: '南千住駅', term_taxonomy_id: 5468, popular: false }, { name: '三ノ輪駅', term_taxonomy_id: 5547, popular: false }, { name: '入谷駅', term_taxonomy_id: 5548, popular: false }, { name: '上野駅', term_taxonomy_id: 48, popular: false }, { name: '仲御徒町駅', term_taxonomy_id: 5549, popular: false }, { name: '秋葉原駅', term_taxonomy_id: 91, popular: false }, { name: '小伝馬町駅', term_taxonomy_id: 5550, popular: false }, { name: '人形町駅', term_taxonomy_id: 5314, popular: false }, { name: '茅場町駅', term_taxonomy_id: 5006, popular: false }, { name: '八丁堀駅', term_taxonomy_id: 5008, popular: false }, { name: '築地駅', term_taxonomy_id: 5551, popular: false }, { name: '東銀座駅', term_taxonomy_id: 5315, popular: false }, { name: '銀座駅', term_taxonomy_id: 5045, popular: false }, { name: '日比谷駅', term_taxonomy_id: 75, popular: false }, { name: '霞ヶ関駅', term_taxonomy_id: 5552, popular: false }, { name: '神保町駅', term_taxonomy_id: 5546, popular: false }, { name: '六本木駅', term_taxonomy_id: 5047, popular: false }, { name: '広尾駅', term_taxonomy_id: 31, popular: false }, { name: '恵比寿駅', term_taxonomy_id: 83, popular: false }, { name: '中目黒駅', term_taxonomy_id: 5128, popular: false }],
                                                東京メトロ丸ノ内線: [{ name: '池袋駅', term_taxonomy_id: 32, popular: false }, { name: '新大塚駅', term_taxonomy_id: 5553, popular: false }, { name: '茗荷谷駅', term_taxonomy_id: 5554, popular: false }, { name: '後楽園駅', term_taxonomy_id: 5289, popular: false }, { name: '本郷三町目駅', term_taxonomy_id: 5555, popular: false }, { name: '御茶ノ水駅', term_taxonomy_id: 5026, popular: false }, { name: '淡路町駅', term_taxonomy_id: 5556, popular: false }, { name: '大手町駅', term_taxonomy_id: 27, popular: false }, { name: '東京駅', term_taxonomy_id: 5046, popular: false }, { name: '銀座駅', term_taxonomy_id: 5045, popular: false }, { name: '霞ヶ関駅', term_taxonomy_id: 5552, popular: false }, { name: '国会議事堂駅', term_taxonomy_id: 5284, popular: false }, { name: '赤坂見附駅', term_taxonomy_id: 5154, popular: false }, { name: '四ツ谷駅', term_taxonomy_id: 5014, popular: false }, { name: '四谷三丁目駅', term_taxonomy_id: 5142, popular: false }, { name: '新宿御苑駅', term_taxonomy_id: 5557, popular: false }, { name: '新宿三丁目駅', term_taxonomy_id: 5143, popular: false }, { name: '新宿駅', term_taxonomy_id: 18, popular: false }, { name: '西新宿駅', term_taxonomy_id: 5220, popular: false }, { name: '中野坂上駅', term_taxonomy_id: 5219, popular: false }, { name: '新中野駅', term_taxonomy_id: 5558, popular: false }, { name: '東高円寺駅', term_taxonomy_id: 5217, popular: false }, { name: '新高円寺駅', term_taxonomy_id: 5216, popular: false }, { name: '南阿佐ヶ谷駅', term_taxonomy_id: 5215, popular: false }, { name: '荻窪駅', term_taxonomy_id: 89, popular: false }],
                                                東京メトロ南北線: [{ name: '赤羽岩淵駅', term_taxonomy_id: 5564, popular: false }, { name: '志茂駅', term_taxonomy_id: 5563, popular: false }, { name: '王子神谷駅', term_taxonomy_id: 5562, popular: false }, { name: '王子駅', term_taxonomy_id: 5287, popular: false }, { name: '西ヶ原駅', term_taxonomy_id: 5561, popular: false }, { name: '駒込駅', term_taxonomy_id: 5291, popular: false }, { name: '本駒込駅', term_taxonomy_id: 5560, popular: false }, { name: '東大前駅', term_taxonomy_id: 5290, popular: false }, { name: '後楽園駅', term_taxonomy_id: 5289, popular: false }, { name: '飯田橋駅', term_taxonomy_id: 101, popular: false }, { name: '市ヶ谷駅', term_taxonomy_id: 5140, popular: false }, { name: '四ツ谷駅', term_taxonomy_id: 5014, popular: false }, { name: '永田町駅', term_taxonomy_id: 5197, popular: false }, { name: '溜池山王駅', term_taxonomy_id: 5015, popular: false }, { name: '六本木一丁目駅', term_taxonomy_id: 5559, popular: false }, { name: '麻布十番駅', term_taxonomy_id: 5152, popular: false }, { name: '白金高輪駅', term_taxonomy_id: 51, popular: false }, { name: '白金台駅', term_taxonomy_id: 5256, popular: false }, { name: '目黒駅', term_taxonomy_id: 5013, popular: false }],
                                                東京メトロ千代田線: [{ name: '綾瀬駅', term_taxonomy_id: 5226, popular: false }, { name: '北千住駅', term_taxonomy_id: 39, popular: true }, { name: '町屋駅', term_taxonomy_id: 95, popular: false }, { name: '西日暮里駅', term_taxonomy_id: 5027, popular: false }, { name: '千駄木駅', term_taxonomy_id: 5567, popular: false }, { name: '根津駅', term_taxonomy_id: 5286, popular: false }, { name: '湯島駅', term_taxonomy_id: 5285, popular: false }, { name: '新御茶ノ水駅', term_taxonomy_id: 5566, popular: false }, { name: '大手町駅', term_taxonomy_id: 27, popular: false }, { name: '二重橋前駅', term_taxonomy_id: 5565, popular: false }, { name: '日比谷駅', term_taxonomy_id: 75, popular: false }, { name: '霞ヶ関駅', term_taxonomy_id: 5552, popular: false }, { name: '国会議事堂駅', term_taxonomy_id: 5284, popular: false }, { name: '赤坂駅', term_taxonomy_id: 5283, popular: false }, { name: '乃木坂駅', term_taxonomy_id: 5282, popular: false }, { name: '表参道駅', term_taxonomy_id: 100, popular: false }, { name: '明治神宮前駅', term_taxonomy_id: 5122, popular: false }, { name: '代々木公園駅', term_taxonomy_id: 5124, popular: false }, { name: '代々木上原駅', term_taxonomy_id: 5281, popular: false }],
                                                東京メトロ東西線: [{ name: '中野駅', term_taxonomy_id: 5012, popular: false }, { name: '落合駅', term_taxonomy_id: 5568, popular: false }, { name: '高田馬場駅', term_taxonomy_id: 19, popular: false }, { name: '早稲田駅', term_taxonomy_id: 5203, popular: false }, { name: '神楽坂駅', term_taxonomy_id: 5202, popular: false }, { name: '飯田橋駅', term_taxonomy_id: 101, popular: false }, { name: '九段下駅', term_taxonomy_id: 102, popular: false }, { name: '竹橋駅', term_taxonomy_id: 5569, popular: false }, { name: '大手町駅', term_taxonomy_id: 27, popular: false }, { name: '日本橋駅', term_taxonomy_id: 5007, popular: false }, { name: '茅場町駅', term_taxonomy_id: 5006, popular: false }, { name: '門前仲町駅', term_taxonomy_id: 113, popular: false }, { name: '木場駅', term_taxonomy_id: 5570, popular: false }, { name: '東陽町駅', term_taxonomy_id: 5571, popular: false }, { name: '南砂町駅', term_taxonomy_id: 5396, popular: false }, { name: '西葛西駅', term_taxonomy_id: 5572, popular: false }, { name: '葛西駅', term_taxonomy_id: 23, popular: false }, { name: '浦安駅', term_taxonomy_id: 5573, popular: false }, { name: '南行徳駅', term_taxonomy_id: 5055, popular: false }, { name: '行徳駅', term_taxonomy_id: 5574, popular: false }, { name: '妙典駅', term_taxonomy_id: 112, popular: false }, { name: '原木中山駅', term_taxonomy_id: 5575, popular: false }, { name: '西船橋駅', term_taxonomy_id: 24, popular: false }],
                                                東京メトロ有楽町線: [{ name: '和光市駅', term_taxonomy_id: 43, popular: false }, { name: '成増駅', term_taxonomy_id: 5117, popular: false }, { name: '赤塚駅', term_taxonomy_id: 5576, popular: false }, { name: '平和台駅', term_taxonomy_id: 5577, popular: false }, { name: '氷川台駅', term_taxonomy_id: 5578, popular: false }, { name: '小竹向原駅', term_taxonomy_id: 5177, popular: false }, { name: '千川駅', term_taxonomy_id: 5579, popular: false }, { name: '要町駅', term_taxonomy_id: 5580, popular: false }, { name: '池袋駅', term_taxonomy_id: 32, popular: false }, { name: '東池袋駅', term_taxonomy_id: 5581, popular: false }, { name: '護国寺駅', term_taxonomy_id: 5200, popular: false }, { name: '江戸川橋駅', term_taxonomy_id: 5199, popular: false }, { name: '飯田橋駅', term_taxonomy_id: 101, popular: false }, { name: '市ヶ谷駅', term_taxonomy_id: 5140, popular: false }, { name: '麹町駅', term_taxonomy_id: 5198, popular: false }, { name: '永田町駅', term_taxonomy_id: 5197, popular: false }, { name: '桜田門駅', term_taxonomy_id: 5196, popular: false }, { name: '有楽町駅', term_taxonomy_id: 5108, popular: false }, { name: '銀座一丁目駅', term_taxonomy_id: 5195, popular: false }, { name: '新富町駅', term_taxonomy_id: 5194, popular: false }, { name: '月島駅', term_taxonomy_id: 5193, popular: false }, { name: '豊洲駅', term_taxonomy_id: 5192, popular: false }, { name: '辰巳駅', term_taxonomy_id: 5191, popular: false }, { name: '新木場駅', term_taxonomy_id: 5190, popular: false }],
                                                都営浅草線: [{ name: '西馬込駅', term_taxonomy_id: 5582, popular: false }, { name: '馬込駅', term_taxonomy_id: 5583, popular: false }, { name: '中延駅', term_taxonomy_id: 5148, popular: false }, { name: '戸越駅', term_taxonomy_id: 5584, popular: false }, { name: '五反田駅', term_taxonomy_id: 5029, popular: false }, { name: '高輪台駅', term_taxonomy_id: 5585, popular: false }, { name: '泉岳寺駅', term_taxonomy_id: 5149, popular: false }, { name: '三田駅', term_taxonomy_id: 5048, popular: false }, { name: '大門駅', term_taxonomy_id: 5586, popular: false }, { name: '新橋駅', term_taxonomy_id: 96, popular: false }, { name: '東銀座駅', term_taxonomy_id: 5315, popular: false }, { name: '宝町駅', term_taxonomy_id: 5587, popular: false }, { name: '日本橋駅', term_taxonomy_id: 5007, popular: false }, { name: '人形町駅', term_taxonomy_id: 5314, popular: false }, { name: '東日本橋駅', term_taxonomy_id: 5157, popular: false }, { name: '浅草橋駅', term_taxonomy_id: 5156, popular: false }, { name: '蔵前駅', term_taxonomy_id: 5588, popular: false }, { name: '浅草駅', term_taxonomy_id: 5351, popular: false }, { name: '本所吾妻橋駅', term_taxonomy_id: 5589, popular: false }, { name: '押上駅', term_taxonomy_id: 46, popular: false }],
                                                都営三田線: [{ name: '目黒駅', term_taxonomy_id: 5013, popular: false }, { name: '白金台駅', term_taxonomy_id: 5256, popular: false }, { name: '白金高輪駅', term_taxonomy_id: 51, popular: false }, { name: '三田駅', term_taxonomy_id: 5048, popular: false }, { name: '芝公園駅', term_taxonomy_id: 5590, popular: false }, { name: '御成門駅', term_taxonomy_id: 5591, popular: false }, { name: '内幸町駅', term_taxonomy_id: 5592, popular: false }, { name: '日比谷駅', term_taxonomy_id: 75, popular: false }, { name: '大手町駅', term_taxonomy_id: 27, popular: false }, { name: '神保町駅', term_taxonomy_id: 5546, popular: false }, { name: '水道橋駅', term_taxonomy_id: 5347, popular: false }, { name: '春日駅', term_taxonomy_id: 5593, popular: false }, { name: '白山駅', term_taxonomy_id: 5594, popular: false }, { name: '千石駅', term_taxonomy_id: 5595, popular: false }, { name: '巣鴨駅', term_taxonomy_id: 5324, popular: false }, { name: '西巣鴨駅', term_taxonomy_id: 5596, popular: false }, { name: '新板橋駅', term_taxonomy_id: 5597, popular: false }, { name: '板橋区役所駅', term_taxonomy_id: 5598, popular: false }, { name: '板橋本町駅', term_taxonomy_id: 5599, popular: false }, { name: '本蓮沼駅', term_taxonomy_id: 5600, popular: false }, { name: '志村坂上駅', term_taxonomy_id: 5601, popular: false }, { name: '志村三丁目駅', term_taxonomy_id: 5602, popular: false }, { name: '蓮根駅', term_taxonomy_id: 5603, popular: false }, { name: '西台駅', term_taxonomy_id: 5604, popular: false }, { name: '高島平駅', term_taxonomy_id: 5605, popular: false }, { name: '新高島平駅', term_taxonomy_id: 5606, popular: false }, { name: '西高島平駅', term_taxonomy_id: 5607, popular: false }],
                                                都営大江戸線: [{ name: '都庁前駅', term_taxonomy_id: 5608, popular: false }, { name: '東新宿駅', term_taxonomy_id: 5619, popular: false }, { name: '若松河田駅', term_taxonomy_id: 5618, popular: false }, { name: '牛込柳町駅', term_taxonomy_id: 5617, popular: false }, { name: '牛込神楽坂駅', term_taxonomy_id: 5616, popular: false }, { name: '飯田橋駅', term_taxonomy_id: 101, popular: false }, { name: '春日駅', term_taxonomy_id: 5593, popular: false }, { name: '本郷三丁目', term_taxonomy_id: 5555, popular: false }, { name: '上野御徒町駅', term_taxonomy_id: 5615, popular: false }, { name: '新御徒町駅', term_taxonomy_id: 5614, popular: false }, { name: '蔵前駅', term_taxonomy_id: 5588, popular: false }, { name: '両国駅', term_taxonomy_id: 5471, popular: false }, { name: '森下駅', term_taxonomy_id: 5613, popular: false }, { name: '清澄白河駅', term_taxonomy_id: 110, popular: false }, { name: '門前仲町駅', term_taxonomy_id: 113, popular: false }, { name: '月島駅', term_taxonomy_id: 5193, popular: false }, { name: '勝どき駅', term_taxonomy_id: 5612, popular: false }, { name: '築地駅', term_taxonomy_id: 5551, popular: false }, { name: '汐留駅', term_taxonomy_id: 5611, popular: false }, { name: '大門駅', term_taxonomy_id: 5586, popular: false }, { name: '赤羽橋駅', term_taxonomy_id: 5610, popular: false }, { name: '麻布十番駅', term_taxonomy_id: 5152, popular: false }, { name: '六本木駅', term_taxonomy_id: 5047, popular: false }, { name: '青山一丁目駅', term_taxonomy_id: 5201, popular: false }, { name: '国立競技場駅', term_taxonomy_id: 5609, popular: false }, { name: '代々木駅', term_taxonomy_id: 5028, popular: false }, { name: '新宿駅', term_taxonomy_id: 18, popular: false }, { name: '都庁前駅', term_taxonomy_id: 5608, popular: false }, { name: '中野坂上駅', term_taxonomy_id: 5219, popular: false }, { name: '東中野駅', term_taxonomy_id: 5218, popular: false }, { name: '中井駅', term_taxonomy_id: 5620, popular: false }, { name: '落合南長崎駅', term_taxonomy_id: 5621, popular: false }, { name: '新江古田駅', term_taxonomy_id: 5622, popular: false }, { name: '練馬駅', term_taxonomy_id: 5049, popular: false }, { name: '豊島園駅', term_taxonomy_id: 5623, popular: false }, { name: '練馬春日町駅', term_taxonomy_id: 5624, popular: false }, { name: '光が丘駅', term_taxonomy_id: 5625, popular: false }],
                                                都営新宿線: [{ name: '新宿駅', term_taxonomy_id: 18, popular: false }, { name: '新宿三丁目駅', term_taxonomy_id: 5143, popular: false }, { name: '曙橋駅', term_taxonomy_id: 5141, popular: false }, { name: '市ヶ谷駅', term_taxonomy_id: 5140, popular: false }, { name: '九段下駅', term_taxonomy_id: 102, popular: false }, { name: '神保町駅', term_taxonomy_id: 5546, popular: false }, { name: '小川町駅', term_taxonomy_id: 5626, popular: false }, { name: '岩本町駅', term_taxonomy_id: 5627, popular: false }, { name: '馬喰横山駅', term_taxonomy_id: 5628, popular: false }, { name: '浜町駅', term_taxonomy_id: 5629, popular: false }, { name: '森下駅', term_taxonomy_id: 5613, popular: false }, { name: '菊川駅', term_taxonomy_id: 5630, popular: false }, { name: '住吉駅', term_taxonomy_id: 5544, popular: false }, { name: '西大島駅', term_taxonomy_id: 111, popular: false }, { name: '大島駅', term_taxonomy_id: 5631, popular: false }, { name: '東大島駅', term_taxonomy_id: 5632, popular: false }, { name: '船堀駅', term_taxonomy_id: 5633, popular: false }, { name: '一之江駅', term_taxonomy_id: 5635, popular: false }, { name: '瑞江駅', term_taxonomy_id: 5634, popular: false }, { name: '篠崎駅', term_taxonomy_id: 5636, popular: false }, { name: '本八幡駅', term_taxonomy_id: 5475, popular: false }],
                                                東急東横線: [{ name: '渋谷駅', term_taxonomy_id: 29, popular: true }, { name: '代官山駅', term_taxonomy_id: 5637, popular: false }, { name: '中目黒駅', term_taxonomy_id: 5128, popular: false }, { name: '祐天寺駅', term_taxonomy_id: 5224, popular: false }, { name: '学芸大学駅', term_taxonomy_id: 5332, popular: false }, { name: '都立大学駅', term_taxonomy_id: 5109, popular: false }, { name: '自由が丘駅', term_taxonomy_id: 38, popular: true }, { name: '田園調布駅', term_taxonomy_id: 5333, popular: false }, { name: '多摩川駅', term_taxonomy_id: 5638, popular: false }, { name: '新丸子駅', term_taxonomy_id: 5639, popular: false }, { name: '武蔵小杉駅', term_taxonomy_id: 55, popular: true }, { name: '元住吉駅', term_taxonomy_id: 5640, popular: false }, { name: '日吉駅', term_taxonomy_id: 5334, popular: false }, { name: '綱島駅', term_taxonomy_id: 98, popular: false }, { name: '大倉山駅', term_taxonomy_id: 5317, popular: false }, { name: '菊名駅', term_taxonomy_id: 5139, popular: false }, { name: '妙蓮寺駅', term_taxonomy_id: 5641, popular: false }, { name: '白楽駅', term_taxonomy_id: 5316, popular: false }, { name: '東白楽駅', term_taxonomy_id: 5642, popular: false }, { name: '反町駅', term_taxonomy_id: 5643, popular: false }, { name: '横浜駅', term_taxonomy_id: 16, popular: true }, { name: 'みなとみらい駅', term_taxonomy_id: 5271, popular: false }],
                                                東急田園都市線: [{ name: '渋谷駅', term_taxonomy_id: 29, popular: true }, { name: '池尻大橋駅', term_taxonomy_id: 5225, popular: false }, { name: '三軒茶屋駅', term_taxonomy_id: 5126, popular: false }, { name: '駒沢大学駅', term_taxonomy_id: 5228, popular: false }, { name: '桜新町駅', term_taxonomy_id: 5229, popular: false }, { name: '用賀駅', term_taxonomy_id: 5120, popular: false }, { name: '二子玉川駅', term_taxonomy_id: 99, popular: false }, { name: '二子新地駅', term_taxonomy_id: 5110, popular: false }, { name: '高津駅', term_taxonomy_id: 5111, popular: false }, { name: '溝の口駅', term_taxonomy_id: 97, popular: true }, { name: '梶ヶ谷駅', term_taxonomy_id: 5112, popular: false }, { name: '宮崎台駅', term_taxonomy_id: 5113, popular: false }, { name: '宮前平駅', term_taxonomy_id: 5114, popular: false }, { name: '鷺沼駅', term_taxonomy_id: 5189, popular: false }, { name: 'たまプラーザ駅', term_taxonomy_id: 5188, popular: false }, { name: 'あざみ野駅', term_taxonomy_id: 57, popular: false }, { name: '江田駅', term_taxonomy_id: 5301, popular: false }, { name: '市が尾駅', term_taxonomy_id: 5300, popular: false }, { name: '藤ヶ丘駅', term_taxonomy_id: 5299, popular: false }, { name: '青葉台駅', term_taxonomy_id: 44, popular: false }, { name: '田奈駅', term_taxonomy_id: 5644, popular: false }, { name: '長津田駅', term_taxonomy_id: 5335, popular: false }, { name: 'つくし野駅', term_taxonomy_id: 5645, popular: false }, { name: 'すずかけ台駅', term_taxonomy_id: 5646, popular: false }, { name: '南町田駅', term_taxonomy_id: 5647, popular: false }, { name: 'つきみ野駅', term_taxonomy_id: 5648, popular: false }, { name: '中央林間駅', term_taxonomy_id: 5336, popular: false }],
                                                東急大井町線: [{ name: '大井町駅', term_taxonomy_id: 84, popular: false }, { name: '下神明駅', term_taxonomy_id: 5147, popular: false }, { name: '戸越公園駅', term_taxonomy_id: 5649, popular: false }, { name: '中延駅', term_taxonomy_id: 5148, popular: false }, { name: '荏原町駅', term_taxonomy_id: 5650, popular: false }, { name: '旗の台駅', term_taxonomy_id: 5651, popular: false }, { name: '北千束駅', term_taxonomy_id: 5652, popular: false }, { name: '大岡山駅', term_taxonomy_id: 5230, popular: false }, { name: '緑が丘駅', term_taxonomy_id: 5653, popular: false }, { name: '自由が丘駅', term_taxonomy_id: 38, popular: true }, { name: '九品仏駅', term_taxonomy_id: 5654, popular: false }, { name: '尾山台駅', term_taxonomy_id: 5249, popular: false }, { name: '等々力駅', term_taxonomy_id: 5127, popular: false }, { name: '上野毛駅', term_taxonomy_id: 5248, popular: false }, { name: '二子玉川駅', term_taxonomy_id: 99, popular: false }, { name: '二子新地駅', term_taxonomy_id: 5110, popular: false }, { name: '高津駅', term_taxonomy_id: 5111, popular: false }, { name: '溝の口駅', term_taxonomy_id: 97, popular: true }],
                                                東急池上線: [{ name: '五反田駅', term_taxonomy_id: 5029, popular: false }, { name: '大崎広小路駅', term_taxonomy_id: 5655, popular: false }, { name: '戸越銀座駅', term_taxonomy_id: 5656, popular: false }, { name: '荏原中延駅', term_taxonomy_id: 5657, popular: false }, { name: '旗の台駅', term_taxonomy_id: 5651, popular: false }, { name: '長原駅', term_taxonomy_id: 5658, popular: false }, { name: '洗足池駅', term_taxonomy_id: 5659, popular: false }, { name: '石川台駅', term_taxonomy_id: 5660, popular: false }, { name: '雪が谷大塚駅', term_taxonomy_id: 5661, popular: false }, { name: '御嶽山駅', term_taxonomy_id: 5662, popular: false }, { name: '久が原駅', term_taxonomy_id: 5664, popular: false }, { name: '千鳥町駅', term_taxonomy_id: 5664, popular: false }, { name: '池上駅', term_taxonomy_id: 5665, popular: false }, { name: '蓮沼駅', term_taxonomy_id: 5666, popular: false }, { name: '蒲田駅', term_taxonomy_id: 37, popular: true }],
                                                東急目黒線: [{ name: '目黒駅', term_taxonomy_id: 5013, popular: false }, { name: '武蔵小山駅', term_taxonomy_id: 5668, popular: false }, { name: '西小山駅', term_taxonomy_id: 5669, popular: false }, { name: '千束駅', term_taxonomy_id: 5670, popular: false }, { name: '大岡山駅', term_taxonomy_id: 5230, popular: false }, { name: '奥沢駅', term_taxonomy_id: 5671, popular: false }, { name: '田園調布駅', term_taxonomy_id: 5333, popular: false }, { name: '多摩川駅', term_taxonomy_id: 5638, popular: false }, { name: '新丸子駅', term_taxonomy_id: 5639, popular: false }, { name: '武蔵小杉駅', term_taxonomy_id: 55, popular: true }, { name: '元住吉駅', term_taxonomy_id: 5640, popular: false }, { name: '日吉駅', term_taxonomy_id: 5334, popular: false }],
                                                京急本線: [{ name: '泉岳寺駅', term_taxonomy_id: 5149, popular: false }, { name: '品川駅', term_taxonomy_id: 42, popular: false }, { name: '大森海岸駅', term_taxonomy_id: 5302, popular: false }, { name: '平和島駅', term_taxonomy_id: 5303, popular: false }, { name: '大森町駅', term_taxonomy_id: 5304, popular: false }, { name: '梅屋敷駅', term_taxonomy_id: 5305, popular: false }, { name: '京急蒲田駅', term_taxonomy_id: 5306, popular: false }, { name: '川崎駅', term_taxonomy_id: 52, popular: false }, { name: '鶴見駅', term_taxonomy_id: 5327, popular: false }, { name: '横浜駅', term_taxonomy_id: 16, popular: true }, { name: '上大岡駅', term_taxonomy_id: 106, popular: false }, { name: '金沢文庫駅', term_taxonomy_id: 5346, popular: false }, { name: '逗子駅', term_taxonomy_id: 115, popular: false }, { name: '横須賀駅', term_taxonomy_id: 49, popular: false }, { name: '久里浜駅', term_taxonomy_id: 5331, popular: false }],
                                                京急大師線: [{ name: '川崎駅', term_taxonomy_id: 52, popular: false }, { name: '港町駅', term_taxonomy_id: 5673, popular: false }, { name: '鈴木町駅', term_taxonomy_id: 5674, popular: false }, { name: '川崎大師駅', term_taxonomy_id: 5675, popular: false }, { name: '東門前駅', term_taxonomy_id: 5676, popular: false }, { name: '産業道路駅', term_taxonomy_id: 5677, popular: false }, { name: '小島新田駅', term_taxonomy_id: 5672, popular: false }],
                                                横浜市営地下鉄線: [{ name: 'あざみ野駅', term_taxonomy_id: 57, popular: false }, { name: 'センター北駅', term_taxonomy_id: 85, popular: false }, { name: '新横浜駅', term_taxonomy_id: 5125, popular: false }, { name: '横浜駅', term_taxonomy_id: 16, popular: true }, { name: '桜木町駅', term_taxonomy_id: 107, popular: false }, { name: '上大岡駅', term_taxonomy_id: 106, popular: false }, { name: '戸塚駅', term_taxonomy_id: 5119, popular: false }, { name: '湘南台駅', term_taxonomy_id: 5260, popular: false }],
                                                相鉄線: [{ name: '横浜駅', term_taxonomy_id: 16, popular: true }, { name: '大和駅', term_taxonomy_id: 5345, popular: false }, { name: '海老名駅', term_taxonomy_id: 88, popular: false }],
                                                小田急小田原線: [{ name: '新宿駅', term_taxonomy_id: 18, popular: false }, { name: '代々木八幡駅', term_taxonomy_id: 5123, popular: false }, { name: '代々木上原駅', term_taxonomy_id: 5281, popular: false }, { name: '下北沢駅', term_taxonomy_id: 28, popular: false }, { name: '経堂駅', term_taxonomy_id: 5341, popular: false }, { name: '千歳船橋駅', term_taxonomy_id: 5342, popular: false }, { name: '祖師ヶ谷大蔵駅', term_taxonomy_id: 5167, popular: false }, { name: '成城学園前駅', term_taxonomy_id: 5343, popular: false }, { name: '喜多見駅', term_taxonomy_id: 5678, popular: false }, { name: '登戸駅', term_taxonomy_id: 5059, popular: false }, { name: '向ヶ丘遊園駅', term_taxonomy_id: 5679, popular: false }, { name: '新百合ヶ丘駅', term_taxonomy_id: 5051, popular: false }, { name: '町田駅', term_taxonomy_id: 47, popular: false }, { name: '相模大野駅', term_taxonomy_id: 5044, popular: false }, { name: '小田急相模原駅', term_taxonomy_id: 5130, popular: false }, { name: '相武台前駅', term_taxonomy_id: 5131, popular: false }, { name: '座間駅', term_taxonomy_id: 5129, popular: false }, { name: '小田急永山駅', term_taxonomy_id: 5232, popular: false }, { name: '海老名駅', term_taxonomy_id: 88, popular: false }, { name: '本厚木駅', term_taxonomy_id: 5173, popular: false }, { name: '東海大学前駅', term_taxonomy_id: 5680, popular: false }, { name: '秦野駅', term_taxonomy_id: 5344, popular: false }, { name: '小田原駅', term_taxonomy_id: 5023, popular: false }],
                                                小田急江ノ島線: [{ name: '相模大野駅', term_taxonomy_id: 5044, popular: false }, { name: '中央林間駅', term_taxonomy_id: 5336, popular: false }, { name: '大和駅', term_taxonomy_id: 5345, popular: false }, { name: '湘南台駅', term_taxonomy_id: 5260, popular: false }, { name: '六会日大前駅', term_taxonomy_id: 5259, popular: false }, { name: '善行駅', term_taxonomy_id: 5258, popular: false }, { name: '藤沢本町駅', term_taxonomy_id: 5257, popular: false }, { name: '藤沢駅', term_taxonomy_id: 77, popular: false }, { name: '本鵠沼駅', term_taxonomy_id: 5261, popular: false }, { name: '鵠沼海岸駅', term_taxonomy_id: 5262, popular: false }, { name: '片瀬江ノ島駅', term_taxonomy_id: 5263, popular: false }],
                                                江ノ島電鉄線: [{ name: '藤沢駅', term_taxonomy_id: 77, popular: false }, { name: '鎌倉高校前駅', term_taxonomy_id: 5264, popular: false }, { name: '七里ヶ浜駅', term_taxonomy_id: 5265, popular: false }, { name: '稲村ヶ崎駅', term_taxonomy_id: 5266, popular: false }, { name: '極楽寺駅', term_taxonomy_id: 5267, popular: false }, { name: '長谷駅', term_taxonomy_id: 5268, popular: false }, { name: '由比ヶ浜駅', term_taxonomy_id: 5269, popular: false }, { name: '和田塚駅', term_taxonomy_id: 5270, popular: false }, { name: '鎌倉駅', term_taxonomy_id: 5159, popular: false }],
                                                京王線: [{ name: '新宿駅', term_taxonomy_id: 18, popular: false }, { name: '初台駅', term_taxonomy_id: 5214, popular: false }, { name: '幡ヶ谷駅', term_taxonomy_id: 5213, popular: false }, { name: '笹塚駅', term_taxonomy_id: 5212, popular: false }, { name: '代田橋駅', term_taxonomy_id: 5211, popular: false }, { name: '明大前駅', term_taxonomy_id: 5009, popular: false }, { name: '下高井戸駅', term_taxonomy_id: 5210, popular: false }, { name: '桜上水駅', term_taxonomy_id: 5209, popular: false }, { name: '上北沢駅', term_taxonomy_id: 5208, popular: false }, { name: '八幡山駅', term_taxonomy_id: 5207, popular: false }, { name: '芦花公園', term_taxonomy_id: 5206, popular: false }, { name: '千歳烏山駅', term_taxonomy_id: 5166, popular: false }, { name: '仙川駅', term_taxonomy_id: 5205, popular: false }, { name: 'つつじヶ丘駅', term_taxonomy_id: 5175, popular: false }, { name: '国領駅', term_taxonomy_id: 5231, popular: false }, { name: '調布駅', term_taxonomy_id: 50, popular: false }, { name: '府中駅', term_taxonomy_id: 79, popular: false }, { name: '八王子駅', term_taxonomy_id: 56, popular: false }, { name: '京王永山駅', term_taxonomy_id: 5010, popular: false }, { name: '京王多摩センター駅', term_taxonomy_id: 5060, popular: false }, { name: '橋本駅', term_taxonomy_id: 5011, popular: false }],
                                                京成本線: [{ name: '上野駅', term_taxonomy_id: 48, popular: false }, { name: '日暮里駅', term_taxonomy_id: 5016, popular: false }, { name: '町屋駅', term_taxonomy_id: 95, popular: false }, { name: '青砥駅', term_taxonomy_id: 5690, popular: false }, { name: '京成高砂駅', term_taxonomy_id: 5691, popular: false }, { name: '京成小岩駅', term_taxonomy_id: 5692, popular: false }, { name: '江戸川駅', term_taxonomy_id: 5693, popular: false }, { name: '国府台駅', term_taxonomy_id: 5694, popular: false }, { name: '市川真間駅', term_taxonomy_id: 5695, popular: false }, { name: '菅野駅', term_taxonomy_id: 5696, popular: false }, { name: '京成八幡駅', term_taxonomy_id: 5697, popular: false }, { name: '鬼越駅', term_taxonomy_id: 5698, popular: false }, { name: '京成中山駅', term_taxonomy_id: 5699, popular: false }, { name: '京成船橋駅', term_taxonomy_id: 5279, popular: false }, { name: '八千代台駅', term_taxonomy_id: 94, popular: false }, { name: '勝田台駅', term_taxonomy_id: 78, popular: false }, { name: 'ユーカリが丘駅', term_taxonomy_id: 5155, popular: false }],
                                                新京成線: [{ name: '津田沼駅', term_taxonomy_id: 40, popular: false }, { name: '習志野駅', term_taxonomy_id: 5275, popular: false }, { name: '新鎌ケ谷駅', term_taxonomy_id: 5163, popular: false }, { name: '北初富駅', term_taxonomy_id: 5239, popular: false }, { name: 'くぬぎ山駅', term_taxonomy_id: 5240, popular: false }, { name: '元山駅', term_taxonomy_id: 5241, popular: false }, { name: '五香駅', term_taxonomy_id: 5165, popular: false }, { name: '常磐平駅', term_taxonomy_id: 5242, popular: false }, { name: '八柱駅', term_taxonomy_id: 5164, popular: false }, { name: 'みのり台駅', term_taxonomy_id: 5243, popular: false }, { name: '松戸新田駅', term_taxonomy_id: 5244, popular: false }, { name: '上本郷駅', term_taxonomy_id: 5253, popular: false }, { name: '松戸駅', term_taxonomy_id: 109, popular: false }],
                                                西武新宿線: [{ name: '西武新宿駅', term_taxonomy_id: 5222, popular: false }, { name: '高田馬場駅', term_taxonomy_id: 19, popular: false }, { name: '鷺ノ宮駅', term_taxonomy_id: 5134, popular: false }, { name: '井荻駅', term_taxonomy_id: 5221, popular: false }, { name: '上井草駅', term_taxonomy_id: 5223, popular: false }, { name: '上石神井駅', term_taxonomy_id: 5137, popular: false }, { name: '武蔵関駅', term_taxonomy_id: 5136, popular: false }, { name: '花小金井駅', term_taxonomy_id: 87, popular: false }],
                                                西武池袋線: [{ name: '池袋駅', term_taxonomy_id: 32, popular: false }, { name: '練馬駅', term_taxonomy_id: 5049, popular: false }, { name: '中村橋駅', term_taxonomy_id: 5133, popular: false }, { name: '富士見台駅', term_taxonomy_id: 5050, popular: false }, { name: '練馬高野台駅', term_taxonomy_id: 5681, popular: false }, { name: '石神井公園駅', term_taxonomy_id: 5682, popular: false }, { name: '大泉学園駅', term_taxonomy_id: 5683, popular: false }, { name: '保谷駅', term_taxonomy_id: 5684, popular: false }, { name: 'ひばりが丘駅', term_taxonomy_id: 5135, popular: false }, { name: '東久留米駅', term_taxonomy_id: 86, popular: false }, { name: '秋津駅', term_taxonomy_id: 5685, popular: false }, { name: '所沢駅', term_taxonomy_id: 5686, popular: false }, { name: '飯能駅', term_taxonomy_id: 26, popular: false }],
                                                東武東上線: [{ name: '池袋駅', term_taxonomy_id: 32, popular: false }, { name: '上板橋駅', term_taxonomy_id: 5178, popular: false }, { name: '成増駅', term_taxonomy_id: 5117, popular: false }, { name: '和光市駅', term_taxonomy_id: 43, popular: false }, { name: '朝霞駅', term_taxonomy_id: 5115, popular: false }, { name: '志木駅', term_taxonomy_id: 5116, popular: false }, { name: 'みずほ台駅', term_taxonomy_id: 5687, popular: false }, { name: '鶴瀬駅', term_taxonomy_id: 5688, popular: false }, { name: 'ふじみ野駅', term_taxonomy_id: 5403, popular: false }, { name: '上福岡駅', term_taxonomy_id: 5689, popular: false }, { name: '川越駅', term_taxonomy_id: 5161, popular: false }],
                                                東武野田線: [{ name: '大宮駅', term_taxonomy_id: 54, popular: false }, { name: '春日部駅', term_taxonomy_id: 5309, popular: false }, { name: '新鎌ケ谷駅', term_taxonomy_id: 5163, popular: false }, { name: '船橋駅', term_taxonomy_id: 93, popular: false }],
                                                東武伊勢崎線: [{ name: '浅草駅', term_taxonomy_id: 5351, popular: false }, { name: '北千住駅', term_taxonomy_id: 39, popular: true }, { name: '西新井駅', term_taxonomy_id: 5308, popular: false }, { name: '竹ノ塚駅', term_taxonomy_id: 5700, popular: false }, { name: '草加駅', term_taxonomy_id: 5701, popular: false }, { name: '新越谷駅', term_taxonomy_id: 5702, popular: false }, { name: '越谷駅', term_taxonomy_id: 5307, popular: false }, { name: 'せんげん台駅', term_taxonomy_id: 92, popular: false }, { name: '春日部駅', term_taxonomy_id: 5309, popular: false }],
                                                東葉高速鉄道: [{ name: '西船橋駅', term_taxonomy_id: 24, popular: false }, { name: '八千代緑ヶ丘駅', term_taxonomy_id: 81, popular: false }, { name: '八千代中央駅', term_taxonomy_id: 5320, popular: false }, { name: '東葉勝田台駅', term_taxonomy_id: 5318, popular: false }]
                                    };
                        }
            }, {
                        key: 'popularStations',
                        get: function get() {
                                    var popular_stations = [];

                                    for (var route in this.json) {
                                                if (!this.json.hasOwnProperty(route)) {
                                                            continue;
                                                }

                                                var stations = this.json[route];

                                                var _loop2 = function _loop2(idx) {
                                                            if (!stations.hasOwnProperty(idx)) {
                                                                        return 'continue';
                                                            }
                                                            var station = stations[idx];

                                                            if (station.popular && !popular_stations.some(function (exist) {
                                                                        return exist.term_taxonomy_id === station.term_taxonomy_id;
                                                            })) {
                                                                        popular_stations.push(station);
                                                            }
                                                };

                                                for (var idx in stations) {
                                                            var _ret2 = _loop2(idx);

                                                            if (_ret2 === 'continue') continue;
                                                }
                                    }

                                    return popular_stations;
                        }
            }, {
                        key: 'routes',
                        get: function get() {
                                    var routes = [];
                                    for (var route in this.json) {
                                                if (!this.json.hasOwnProperty(route)) {
                                                            continue;
                                                }
                                                routes.push(route);
                                    }

                                    return routes;
                        }
            }]);

            return Stations;
}();

exports.default = Stations;

},{"../utils/ObjectUtil":25}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MyClass2 = require('../plugins/MyClass');

var _MyClass3 = _interopRequireDefault(_MyClass2);

var _TypeUtil = require('../utils/TypeUtil');

var _TypeUtil2 = _interopRequireDefault(_TypeUtil);

var _Stations = require('./Stations');

var _Stations2 = _interopRequireDefault(_Stations);

var _util = require('../utils/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Teacher = function (_MyClass) {
    _inherits(Teacher, _MyClass);

    function Teacher(data) {
        _classCallCheck(this, Teacher);

        var _this = _possibleConstructorReturn(this, (Teacher.__proto__ || Object.getPrototypeOf(Teacher)).call(this, data));

        _this.classname = 'Teacher';
        _this.stations = [];
        return _this;
    }

    _createClass(Teacher, [{
        key: 'availableStations',
        value: function availableStations() {
            var stations = [];

            for (var idx in this.stations) {
                if (!this.stations.hasOwnProperty(idx)) {
                    continue;
                }
                stations.push(_Stations2.default.station(this.stations[idx]));
            }

            return stations;
        }
    }, {
        key: 'mergeStations',
        value: function mergeStations(term_taxonomy_ids) {
            var _this2 = this;

            term_taxonomy_ids = _TypeUtil2.default.typeOfArray(term_taxonomy_ids) ? term_taxonomy_ids : [term_taxonomy_ids];

            var _loop = function _loop(idx) {
                if (!term_taxonomy_ids.hasOwnProperty(idx)) {
                    return 'continue';
                }

                var term_taxonomy_id = term_taxonomy_ids[idx];

                if (!_this2.stations.some(function (station_id) {
                    return station_id === term_taxonomy_id;
                })) {
                    _this2.stations.push(term_taxonomy_id);
                }
            };

            for (var idx in term_taxonomy_ids) {
                var _ret = _loop(idx);

                if (_ret === 'continue') continue;
            }
        }
    }, {
        key: 'getMeta',
        value: function getMeta(key) {

            for (var idx in this.meta) {
                if (!this.meta.hasOwnProperty(idx)) {
                    continue;
                }

                var meta = this.meta[idx];

                if (meta.meta_key === key && meta.meta_value !== '' // 何らかの理由で過去に同名のキーが空白で登録されているケースの対策
                ) {
                        return meta.meta_value;
                    }
            }

            return false;
        }
    }, {
        key: 'getTaxonomies',
        value: function getTaxonomies(taxonomy) {
            if ((0, _util.empty)(this.taxonomies)) {
                return false;
            }

            var favorites = this.taxonomies.filter(function (tax) {
                return tax.taxonomy === taxonomy;
            });

            return (0, _util.empty)(favorites) ? false : favorites;
        }
    }, {
        key: 'name',
        get: function get() {
            return this.teacher_name ? this.teacher_name : this.getMeta('teacher_name');
        }
    }, {
        key: 'photo_url',
        get: function get() {
            return this.teacher_photo_url ? this.teacher_photo_url : this.getMeta('teacher_photo_url');
        }
    }, {
        key: 'area',
        get: function get() {
            return this.teacher_area ? this.teacher_area : this.getMeta('teacher_area');
        }
    }, {
        key: 'reviews',
        get: function get() {
            return !(0, _util.empty)(this.student_reviews) ? this.student_reviews : false;
        }
    }, {
        key: 'reports',
        get: function get() {
            return !(0, _util.empty)(this.lesson_reports) ? this.lesson_reports : false;
        }
    }, {
        key: 'exskill',
        get: function get() {
            return this.teacher_exskill ? this.teacher_exskill : this.getMeta('teacher_exskill');
        }
    }, {
        key: 'message',
        get: function get() {
            return this.teacher_message ? this.teacher_message : this.getMeta('teacher_message');
        }
    }, {
        key: 'experience',
        get: function get() {
            return this.teacher_experience ? this.teacher_experience : this.getMeta('teacher_experience');
        }
    }, {
        key: 'qualification',
        get: function get() {
            return this.teacher_qualification ? this.teacher_qualification : this.getMeta('teacher_qualification');
        }
    }, {
        key: 'favorites',
        get: function get() {
            return !(0, _util.empty)(this.teacher_favorites) ? this.teacher_favorites : this.getTaxonomies('favorite_lesson');
        }
    }, {
        key: 'videos',
        get: function get() {

            //         return this.teacher_videos ? this.teacher_videos : this.getMeta('teacher_videos');

            var videos = (0, _util.empty)(this.teacher_videos) ? this.teacher_videos : this.getMeta('teacher_videos');

            var arr = [];

            if (videos) {
                for (var v in videos) {
                    if (!videos.hasOwnProperty(v)) {
                        continue;
                    }
                    arr.push(videos[v]);
                }
            }

            return arr;
        }
    }, {
        key: 'interview_before',
        get: function get() {
            return this.teacher_interview_before ? this.teacher_interview_before : this.getMeta('teacher_interview_before');
        }
    }, {
        key: 'interview_after',
        get: function get() {
            return this.teacher_interview_after ? this.teacher_interview_after : this.getMeta('teacher_interview_after ');
        }
    }, {
        key: 'interview',
        get: function get() {
            return !(0, _util.empty)(this.teacher_interview) ? this.teacher_interview : this.getMeta('teacher_interview');
        }
    }]);

    return Teacher;
}(_MyClass3.default);

exports.default = Teacher;

},{"../plugins/MyClass":17,"../utils/TypeUtil":26,"../utils/util":28,"./Stations":7}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Comment = require('./Comment.vue');

var _Comment2 = _interopRequireDefault(_Comment);

var _CommentLink = require('./CommentLink.vue');

var _CommentLink2 = _interopRequireDefault(_CommentLink);

var _Teacher = require('./Teacher');

var _Teacher2 = _interopRequireDefault(_Teacher);

var _PostCollection = require('./../plugins/wordpress-posts/PostCollection');

var _PostCollection2 = _interopRequireDefault(_PostCollection);

var _util = require('../utils/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    components: { CommentView: _Comment2.default, CommentLink: _CommentLink2.default },

    data: function data() {
        return {
            teacher: {
                default: undefined,
                type: _Teacher2.default
            },

            visible: false,
            commentContents: new _PostCollection2.default()
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('teacher-was-retrieved', function (teacher) {
            _this.teacher = _Teacher2.default.is('Teacher', teacher) ? teacher : new _Teacher2.default(teacher);

            _this.visible = true;

            $('body').css('overflow', 'hidden');

            _this.$nextTick(function () {
                $('#detail').scrollTop(0).on('click', '[data-lity]', lity);
            });
        });
    },


    methods: {

        //            hasReviews(){
        //                return !empty(this.teacher.reviews);
        //            },

        commentTitle: function commentTitle(comment) {

            var content = comment.comment_content;
            var m = content.match(/<strong>(.*?)<\/strong>/i);
            content = (m != null ? m[1] : content).replace(/(\(|（).*(\)|）)/g, '');

            return content;
        },
        commentContent: function commentContent(comment) {
            var comment_post_id = this.commentPostId(comment);
            return this.commentContents.get(comment_post_id) !== null ? this.commentContents.get(comment_post_id).content : false;
        },
        onCommentClicked: function onCommentClicked(comment) {
            var _this2 = this;

            if (false !== this.commentContent(comment)) {
                return;
            }

            comment.loading = true;

            // コメントの本体となるPOSTのIDを類推する（URLのルールが変われば失敗する可能性ある）
            var comment_post_id = this.commentPostId(comment);

            //ビギンにおけるコメントは本体となるPostが存在するので、その本体取得する
            this.$http.get('/comment/' + comment_post_id).then(function (response) {
                _this2.commentContents.push(response.data);
                comment.loading = false;
            }).catch(function (err) {
                console.error(err);
            });
        },
        commentPostId: function commentPostId(comment) {
            var m = comment.comment_author_url.match(/(\d+).php/i);
            if (m === null) {
                return;
            }
            return m[1];
        },
        onCommentBlur: function onCommentBlur(comment) {
            //                $('#comment-' + comment.comment_ID).popover('hide');
        },
        onCloseBtnClicked: function onCloseBtnClicked() {
            this.visible = false;
            $('body').css('overflow', 'auto');
            Event.$emit('teacher-detail-was-closed');
            $('#detail').off('click', '[data-lity]', lity);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <transition name=\"fade\">\n        <section id=\"teacher-detail\" v-show=\"visible\" class=\"teacher-search__cover\" @click.prevent.stop=\"onCloseBtnClicked\">\n            <a href=\"#\" class=\"teacher-search__detail-close-btn\" @click.prevent.stop=\"onCloseBtnClicked\">\n                × 閉じる\n            </a>\n\n            <article id=\"detail\" class=\"teacher-search__detail\" @click.stop=\"\">\n                <header class=\"teacher-search__detail-header\">\n                    <img :src=\"teacher.photo_url\" :alt=\"teacher.name + 'の顔写真'\" class=\"teacher-search__avatar\">\n                    <div class=\"teacher-search__subtitle\">{{ teacher.name }}</div>\n\n                    <div class=\"teacher-search__message\">\n                        <h5 class=\"teacher-search__minititle\">\n                            <i class=\"microphone\"></i>\n                            講師からのメッセージ\n                        </h5>\n                        {{ teacher.message }}\n\n                        <a :href=\"'/try?needs=' + teacher.name + 'との体験レッスンを希望します'\" class=\"teacher-search__detail-submit-btn teacher-search__detail-submit-btn--transparent shown--pc m-t-lg\">\n                            体験レッスンを申込む\n                        </a>\n                    </div>\n                </header>\n\n                <div class=\"teacher-search__detail-content\">\n                    <dl id=\"teacher_area\" class=\"table table-bordered\" v-show=\"teacher.area\">\n                        <dt class=\"col-xs-12 col-sm-4\">指導エリア</dt>\n                        <dd class=\"col-xs-12 col-sm-8\" v-html=\"teacher.area\"></dd>\n                    </dl>\n\n                    <dl id=\"teacher_experience\" class=\"table table-bordered\" v-show=\"teacher.experience\">\n                        <dt class=\"col-xs-12 col-sm-4\">講師経験</dt>\n                        <dd class=\"col-xs-12 col-sm-8\" v-html=\"teacher.experience\"></dd>\n                    </dl>\n\n                    <dl id=\"teacher_exskill\" class=\"table table-bordered\" v-show=\"teacher.exskill\">\n                        <dt class=\"col-xs-12 col-sm-4\">英語以外に精通する分野</dt>\n                        <dd class=\"col-xs-12 col-sm-8\" v-html=\"teacher.exskill\"></dd>\n                    </dl>\n\n                    <dl class=\"table table-bordered\" v-if=\"teacher.favorites\">\n                        <dt class=\"col-xs-12 col-sm-4\">得意レッスン</dt>\n                        <dd class=\"col-xs-12 col-sm-8\">\n                            <ul class=\"tags\">\n                                <li v-for=\"(id,title) in teacher.favorites\">\n                                    <a :href=\"'/?p=' + id\" class=\"tag\" target=\"_blank\">\n                                        {{ title }}\n                                    </a>\n                                </li>\n                            </ul>\n                        </dd>\n                    </dl>\n\n                    <div id=\"teacher_videos\" class=\"m-t-lg\" v-show=\"teacher.videos &amp;&amp; teacher.videos.length > 0 &amp;&amp; teacher.videos[0] !==undefined &amp;&amp; teacher.videos[0].v !== undefined\">\n                        <h3>{{ teacher.name }}の動画</h3>\n                        <ul class=\"teacher-search__videos\">\n                            <li v-for=\"video in teacher.videos\">\n                                <a :href=\"'//www.youtube.com/watch?v='+video.v\" data-lity=\"\">\n                                    <img :src=\"'//i.ytimg.com/vi/'+video.v+'/mqdefault.jpg'\">\n                                </a>\n                            </li>\n                        </ul>\n                    </div>\n\n                    <div id=\"teacher_interview_before\" v-show=\"teacher.interview_before\" v-html=\"teacher.interview_before\">\n                    </div>\n\n                    <div id=\"teacher_interview\" v-show=\"teacher.interview\">\n                        <h1 class=\"teacher-search__h1\">\n                            {{ teacher.name }}へのインタビューをご紹介！\n                        </h1>\n                        <div v-html=\"teacher.interview\"></div>\n                    </div>\n\n                    <div id=\"teacher_interview_after\" class=\"m-t-lg\" v-show=\"teacher.interview_after\" v-html=\"teacher.interview_after\">\n                    </div>\n\n                    <div id=\"teacher_reports\" class=\"m-t-lg\" v-show=\"teacher.reports\">\n                        <h5 class=\"teacher-search__minititle text-center lines-on-sides\">\n                            {{ teacher.name }}のレッスン事例\n                        </h5>\n                        <ul class=\"teacher-search__voices m-t\">\n                            <li v-for=\"comment in teacher.reports\">\n                                <comment-link :comment=\"comment\"></comment-link>\n                            </li>\n                        </ul>\n                    </div>\n\n                    <div id=\"teacher_reviews\" class=\"m-t-lg\" v-show=\"teacher.reviews\">\n                        <h5 class=\"teacher-search__minititle text-center lines-on-sides\">\n                            生徒さまからのレビュー\n                        </h5>\n                        <ul class=\"teacher-search__voices m-t\">\n                            <li v-for=\"comment in teacher.reviews\">\n<!--                                <comment-view :comment=\"comment\"></comment-view>-->\n\t\t\t\t\t\t\t\t<comment-link :comment=\"comment\"></comment-link>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n                <footer class=\"teacher-search__detail-footer\">\n                    <a :href=\"'/try?needs=' + teacher.name + 'との体験レッスンを希望します'\" class=\"teacher-search__detail-submit-btn\">\n                        <img :src=\"teacher.photo_url\" class=\"teacher-search__avatar teacher-search__avatar--xs\">\n                        {{ teacher.name }}との体験レッスンを申込む\n                    </a>\n                </footer>\n            </article>\n        </section>\n    </transition>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7923d255", module.exports)
  } else {
    hotAPI.update("_v-7923d255", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../utils/util":28,"./../plugins/wordpress-posts/PostCollection":23,"./Comment.vue":1,"./CommentLink.vue":2,"./Teacher":8,"vue":31,"vue-hot-reload-api":30}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Teacher = require('./Teacher');

var _Teacher2 = _interopRequireDefault(_Teacher);

var _Collection = require('./../plugins/Collection');

var _Collection2 = _interopRequireDefault(_Collection);

var _GetTeacher = require('../jobs/GetTeacher');

var _GetTeacher2 = _interopRequireDefault(_GetTeacher);

var _PostCollection = require('./../plugins/wordpress-posts/PostCollection');

var _PostCollection2 = _interopRequireDefault(_PostCollection);

var _util = require('../utils/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Collection2.default.extend({

    props: {},

    computed: {

        // 先生の重複表示を避けるために、一度別の駅で表示された先生は、駅名欄に駅名を追記するのみにする措置
        unique: function unique() {
            var _this = this;

            var exist_post_ids = [];
            var unique = new _PostCollection2.default();

            var _loop = function _loop(idx) {
                if (!_this.items.hasOwnProperty(idx)) {
                    return 'continue';
                }
                var teacher = _this.items[idx];

                // ユニーク
                if (!exist_post_ids.some(function (id) {
                    return id === teacher.post_id;
                })) {
                    unique.push(teacher);
                    exist_post_ids.push(teacher.post_id);
                    return 'continue';
                }

                var _teacher = unique.get(teacher);

                if (!_teacher) {
                    return 'continue';
                }

                // 既出なら駅を追加する
                _teacher.mergeStations(teacher.stations);
                unique.update(_teacher);
            };

            for (var idx in this.items) {
                var _ret = _loop(idx);

                if (_ret === 'continue') continue;
            }

            return unique;
        }
    },

    data: function data() {
        return {
            getTeacherJob: new _GetTeacher2.default(this)
        };
    },
    created: function created() {
        var _this2 = this;

        Event.$on('teachers-were-retrieved', function (stations) {

            var converted = [];

            for (var sidx in stations) {
                if (!stations.hasOwnProperty(sidx)) {
                    continue;
                }

                var teachers = stations[sidx];

                for (var tidx in teachers) {
                    if (!teachers.hasOwnProperty(tidx)) {
                        continue;
                    }
                    var _teacher2 = new _Teacher2.default(teachers[tidx]);

                    _teacher2.stations.push(sidx);

                    converted.push(_teacher2);
                }
            }

            _this2.items = converted;

            if (_this2.hasNoItem) {
                Event.$emit('show-message', '現在ご指定の駅で活動する講師に空き時間がございません。誠に申し訳ございません。');
                return;
            }

            _this2.$nextTick(function () {
                $('html,body').animate({
                    scrollTop: $('#search-results').offset().top - 100
                }, 'fast');
            });
        });
    },


    methods: {
        detail: function detail(teacher) {
            Event.$emit('loading');

            this.getTeacherJob.handle(teacher);
        },
        onStationClick: function onStationClick(station) {
            Event.$emit('loading');
            Event.$emit('station-was-selected', station.term_taxonomy_id);
        }
    }
});
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<fieldset id=\"search-results\" class=\"teacher-search__element\" v-show=\"hasItem\">\n    <legend class=\"teacher-search__title\">\n        <h2>検索結果</h2>\n        {{ unique.length }}名の講師が見つかりました！\n    </legend>\n\n    <ul class=\"teacher-search__cards\">\n        <li v-for=\"teacher in unique.items\">\n            <article class=\"teacher-search__card\">\n                <header class=\"teacher-search__card-header row\">\n                    <div class=\"col-xs-12 text-center\">\n                        <img :id=\"'gtm-teacher--photo-of-' + teacher.ID\" :src=\"teacher.photo_url\" :alt=\"teacher.name + 'の顔写真'\" class=\"teacher-search__avatar\" :title=\"teacher.name\" @click.prevent=\"detail(teacher)\">\n                        <div>\n                            <a :id=\"'gtm-teacher--name-of-' + teacher.ID\" href=\"#\" class=\"teacher-search__subtitle\" @click.prevent=\"detail(teacher)\" :title=\"teacher.name\">\n                                {{ teacher.name }}\n                            </a>\n                        </div>\n\n                    </div>\n                </header>\n\n                <div class=\"teacher-search__card-content\">\n\n                    <dl class=\"table table-bordered\">\n                        <dt class=\"col-xs-12\">検索と一致するレッスン駅</dt>\n                        <dd class=\"col-xs-12\">\n                            <ul class=\"tags\">\n                                <li v-for=\"station in teacher.availableStations()\">\n                                    <a :id=\"'gtm-station--tag-'+station.term_taxonomy_id\" href=\"#\" class=\"tag\" @click.prevent=\"onStationClick(station)\" :title=\"station.name\">\n                                        {{ station.name }}\n                                    </a>\n                                </li>\n                            </ul>\n                        </dd>\n                    </dl>\n\n                    <dl class=\"table table-bordered\" v-if=\"teacher.favorites\">\n                        <dt class=\"col-xs-12\">得意レッスン</dt>\n                        <dd class=\"col-xs-12\">\n                            <ul class=\"tags\">\n                                <li v-for=\"(id,title) in teacher.favorites\">\n                                    <span class=\"tag\">{{ title }}</span>\n                                </li>\n                            </ul>\n                        </dd>\n                    </dl>\n\n                    <dl class=\"table table-bordered\" v-show=\"teacher.experience\">\n                        <dt class=\"col-xs-12\">講師経験</dt>\n                        <dd class=\"col-xs-12\" v-html=\"teacher.experience\"></dd>\n                    </dl>\n\n                    <dl class=\"table table-bordered\" v-show=\"teacher.exskill\">\n                        <dt class=\"col-xs-12\">英語以外に精通する分野</dt>\n                        <dd class=\"col-xs-12\" v-html=\"teacher.exskill\"></dd>\n                    </dl>\n\n                    <dl class=\"table table-bordered\" v-if=\"teacher.videos &amp;&amp; teacher.videos.length > 0\">\n                        <dt class=\"col-xs-12\">{{ teacher.name }}の動画</dt>\n                        <dd class=\"col-xs-12\">\n                            <ul class=\"teacher-search__videos\">\n                                <li v-for=\"(video,idx) in teacher.videos\">\n                                    <a :href=\"'//www.youtube.com/watch?v='+video.v\" :title=\"teacher.name + 'の動画' + (idx+1)\" data-lity=\"\">\n                                        <img :src=\"'//i.ytimg.com/vi/'+video.v+'/mqdefault.jpg'\">\n                                    </a>\n                                </li>\n                            </ul>\n                        </dd>\n                    </dl>\n\n                    <div v-show=\"teacher.reports\">\n                        <h5 class=\"teacher-search__minititle text-center lines-on-sides\">\n                            {{ teacher.name }}のレッスン事例\n                        </h5>\n                        <ul class=\"teacher-search__voices m-t\">\n                            <li v-for=\"comment in teacher.reports\">\n                                <i class=\"student\"></i>&nbsp;{{ comment }}\n                            </li>\n                        </ul>\n                    </div>\n\n                    <div v-show=\"teacher.reviews\">\n                        <h5 class=\"teacher-search__minititle text-center lines-on-sides\">\n                            生徒さまからのレビュー\n                        </h5>\n                        <ul class=\"teacher-search__voices m-t\">\n                            <li v-for=\"comment in teacher.reviews\">\n                                <i class=\"communication\"></i>&nbsp;{{ comment }}\n                            </li>\n                        </ul>\n                    </div>\n\n                </div>\n                <footer class=\"teacher-search__card-footer\">\n\n                    <a :id=\"'teacher--detail-of-' + teacher.ID\" href=\"#\" class=\"teacher-search__card-submit-btn\" :title=\"teacher.name\" @click.prevent=\"detail(teacher)\">\n                        <img :src=\"teacher.photo_url\" :alt=\"teacher.name + 'の顔写真'\" class=\"teacher-search__avatar teacher-search__avatar--xs\">\n                        {{ teacher.post_title }}\n                    </a>\n                </footer>\n            </article>\n        </li>\n    </ul>\n</fieldset>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-323a8722", module.exports)
  } else {
    hotAPI.update("_v-323a8722", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}
},{"../jobs/GetTeacher":11,"../utils/util":28,"./../plugins/Collection":14,"./../plugins/wordpress-posts/PostCollection":23,"./Teacher":8,"vue":31,"vue-hot-reload-api":30}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _VueJob2 = require('../plugins/VueJob');

var _VueJob3 = _interopRequireDefault(_VueJob2);

var _Cache = require('../plugins/Cache');

var _Cache2 = _interopRequireDefault(_Cache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GetTeacher = function (_VueJob) {
    _inherits(GetTeacher, _VueJob);

    function GetTeacher(vue) {
        _classCallCheck(this, GetTeacher);

        return _possibleConstructorReturn(this, (GetTeacher.__proto__ || Object.getPrototypeOf(GetTeacher)).call(this, vue));
    }

    _createClass(GetTeacher, [{
        key: 'handle',
        value: function handle(teacher) {

            if (_Cache2.default.has('teacher', teacher.post_id)) {
                Event.$emit('loaded');
                Event.$emit('teacher-was-retrieved', JSON.parse(_Cache2.default.get('teacher', teacher.post_id)));
                return;
            }

            this.vue.$http.post('/teacher/' + teacher.post_id).then(function (response) {

                _Cache2.default.set('teacher', teacher.post_id, JSON.stringify(response.data));

                Event.$emit('loaded');

                Event.$emit('teacher-was-retrieved', response.data);
            }).catch(function (error) {
                Event.$emit('loaded');
                console.error(error);
            });
        }
    }]);

    return GetTeacher;
}(_VueJob3.default);

exports.default = GetTeacher;

},{"../plugins/Cache":13,"../plugins/VueJob":22}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _VueJob2 = require('../plugins/VueJob');

var _VueJob3 = _interopRequireDefault(_VueJob2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GetTeachers = function (_VueJob) {
    _inherits(GetTeachers, _VueJob);

    function GetTeachers(vue) {
        _classCallCheck(this, GetTeachers);

        return _possibleConstructorReturn(this, (GetTeachers.__proto__ || Object.getPrototypeOf(GetTeachers)).call(this, vue));
    }

    _createClass(GetTeachers, [{
        key: 'handle',
        value: function handle() {
            var _this2 = this;

            this.vue.form.post('/teachers/').then(function (response) {

                _this2.vue.searched = true;

                Event.$emit('teachers-were-retrieved', response);

                Event.$emit('loaded');
            }).catch(function (err) {
                Event.$emit('loaded');
                console.error(err);
            });
        }
    }]);

    return GetTeachers;
}(_VueJob3.default);

exports.default = GetTeachers;

},{"../plugins/VueJob":22}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Logger = require('../plugins/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _Session = require('./Session');

var _Session2 = _interopRequireDefault(_Session);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cache = function () {
    function Cache() {
        _classCallCheck(this, Cache);
    }

    _createClass(Cache, null, [{
        key: 'has',
        value: function has(prefix, id) {
            if (!_Session2.default.available()) {
                _Logger2.default.error('キャッシュの設定をお確かめください！');
                return false;
            }

            return _Session2.default.has(prefix, id);
        }
    }, {
        key: 'get',
        value: function get(prefix, id) {

            if (!_Session2.default.available()) {
                _Logger2.default.error('キャッシュの設定をお確かめください！');
                return false;
            }

            return _Session2.default.get(prefix, id);
        }
    }, {
        key: 'set',
        value: function set(prefix, id, value) {

            if (!_Session2.default.available()) {
                _Logger2.default.error('キャッシュの設定をお確かめください！');
                return false;
            }

            return _Session2.default.set(prefix, id, value);
        }
    }]);

    return Cache;
}();

exports.default = Cache;
;

},{"../plugins/Logger":15,"./Session":21}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TypeUtil = require('../utils/TypeUtil');

var _TypeUtil2 = _interopRequireDefault(_TypeUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

'use strict';
exports.default = Vue.extend({

    props: ['data'],

    data: function data() {
        return {
            items: this.data,
            isCacheAvailable: 'sessionStorage' in window && window.sessionStorage !== undefined
        };
    },
    created: function created() {
        if (this.items === undefined) {
            this.items = [];
        }
    },


    computed: {
        hasItem: function hasItem() {
            return this.items !== undefined && this.items.length > 0;
        },
        hasNoItem: function hasNoItem() {
            return this.items === undefined || this.items.length === 0;
        },
        size: function size() {
            return this.hasNoItem ? 0 : this.items.length;
        },
        json: function json() {
            return JSON.stringify(this.items);
        }
    },

    methods: {
        filter: function filter(fn) {
            return this.items.filter(fn);
        },
        map: function map(fn) {
            return this.items.map(fn);
        },
        concat: function concat(obj) {
            return this.items.concat(obj);
        },
        push: function push(item) {

            if (!_TypeUtil2.default.typeOfArray(item)) {
                item = [item];
            }

            for (var idx in item) {
                if (!item.hasOwnProperty(idx)) {
                    continue;
                }
                this.items.push(item[idx]);
            }

            this.$emit('added');
        },
        splice: function splice(indexOfItem, count, newValue) {
            this.items.splice(indexOfItem, count, newValue);
            this.$emit('added');
        },
        unshift: function unshift(item) {
            this.items.unshift(item);
            this.$emit('added');
        },
        remove: function remove(index) {
            this.items.splice(index, 1);

            this.$emit('removed');
        },
        exchange: function exchange(index, item) {
            var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            this.remove(index);

            if (bottom) {
                this.push(item);
                return;
            }

            this.unshift(item);
        },
        reset: function reset() {
            this.items.splice(0);
            this.$emit('removed');
        },
        import: function _import(jsonStr_or_array) {
            var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var items = _TypeUtil2.default.typeOfString(jsonStr_or_array) ? JSON.parse(jsonStr_or_array) : jsonStr_or_array;

            if (fn !== null) {
                items = this.convert(items, fn);
            }

            this.items = items;

            this.$emit('added');
        }
    }

});

},{"../utils/TypeUtil":26}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyForm = function () {
    function MyForm() {
        _classCallCheck(this, MyForm);
    }

    _createClass(MyForm, null, [{
        key: 'log',
        value: function log(value) {
            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            if (Vue.config.devtools) {
                console.log(value, key);
            }
        }
    }, {
        key: 'info',
        value: function info(value) {
            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            if (Vue.config.devtools) {
                console.info(value, key);
            }
        }
    }, {
        key: 'warn',
        value: function warn(value) {
            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            if (Vue.config.devtools) {
                console.warn(value, key);
            }
        }
    }, {
        key: 'error',
        value: function error(value) {
            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            if (Vue.config.devtools) {
                console.error(value, key);
            }
        }
    }]);

    return MyForm;
}();

exports.default = MyForm;
;

},{}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// This is your plugin object. It can be exported to be used anywhere.
var MyAxios = {
    // The install method is all that needs to exist on the plugin object.
    // It takes the global Vue object as well as user-defined options.
    install: function install(Vue, options) {
        Vue.prototype.$http = axios.create({
            baseURL: WP_GLOBAL.root,
            headers: {
                //                 "X-WP-Nonce": WP_GLOBAL.nonce
            }
        });
    }
};

exports.default = MyAxios;

// Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(MyAxios);
}

},{}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyClass = function () {

    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    function MyClass(data) {
        _classCallCheck(this, MyClass);

        this.originalData = data;

        for (var field in data) {
            if (!data.hasOwnProperty(field)) {
                continue;
            }
            this[field] = data[field];
        }
    }

    /**
     * Fetch all relevant data for the form.
     */


    _createClass(MyClass, [{
        key: 'data',
        value: function data() {
            var data = {};

            for (var property in this.originalData) {
                if (!this.originalData.hasOwnProperty(property)) {
                    continue;
                }
                data[property] = this[property];
            }

            return data;
        }

        /**
         * Create a new Form instance.
         *
         * @param {string} className
         * @param {object} obj
         */

    }], [{
        key: 'is',
        value: function is(className, obj) {
            return obj.hasOwnProperty('className') && obj.classname === className;
        }
    }]);

    return MyClass;
}();

exports.default = MyClass;

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyErrors = function () {
    /**
     * Create a new Errors instance.
     */
    function MyErrors() {
        _classCallCheck(this, MyErrors);

        this.errors = {};
    }

    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     */


    _createClass(MyErrors, [{
        key: "has",
        value: function has(field) {
            return this.errors.hasOwnProperty(field);
        }

        /**
         * Determine if we have any errors.
         */

    }, {
        key: "any",
        value: function any() {
            return Object.keys(this.errors).length > 0;
        }

        /**
         * Retrieve the error message for a field.
         *
         * @param {string} field
         */

    }, {
        key: "get",
        value: function get(field) {
            if (this.errors[field]) {
                return this.errors[field][0];
            }
        }

        /**
         * Record the new errors.
         *
         * @param {object} errors
         */

    }, {
        key: "record",
        value: function record(errors) {
            this.errors = errors;
        }

        /**
         * Clear one or all error fields.
         *
         * @param {string|null} field
         */

    }, {
        key: "clear",
        value: function clear(field) {
            if (field) {
                delete this.errors[field];

                return;
            }

            this.errors = {};
        }
    }]);

    return MyErrors;
}();

exports.default = MyErrors;

},{}],19:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MyErrors = require('./MyErrors');

var _MyErrors2 = _interopRequireDefault(_MyErrors);

var _TypeUtil = require('../utils/TypeUtil');

var _TypeUtil2 = _interopRequireDefault(_TypeUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyForm = function () {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    function MyForm(data) {
        _classCallCheck(this, MyForm);

        this.originalData = data;

        for (var field in data) {
            if (!data.hasOwnProperty(field)) {
                continue;
            }
            this[field] = data[field];
        }

        this.errors = new _MyErrors2.default();
    }

    /**
     * Fetch all relevant data for the form.
     */


    _createClass(MyForm, [{
        key: 'data',
        value: function data() {
            var data = {};

            for (var property in this.originalData) {
                if (!this.originalData.hasOwnProperty(property)) {
                    continue;
                }
                data[property] = this[property];
            }

            return data;
        }

        /**
         * Reset the form fields.
         */

    }, {
        key: 'reset',
        value: function reset() {
            var _this = this;

            var excepts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';


            excepts = _TypeUtil2.default.typeOfString(excepts) ? [excepts] : excepts;

            var _loop = function _loop(field) {

                if (!_this.originalData.hasOwnProperty(field)) {
                    return 'continue';
                }

                // 例外的にリセットしない
                if (excepts.some(function (except) {
                    return except === field;
                })) {
                    return 'continue';
                }

                if (_TypeUtil2.default.typeOfArray(_this[field])) {
                    _this[field] = [];
                    return 'continue';
                }

                _this[field] = '';
            };

            for (var field in this.originalData) {
                var _ret = _loop(field);

                if (_ret === 'continue') continue;
            }

            this.errors.clear();
        }

        /**
         * Send a POST request to the given URL.
         * .
         * @param {string} url
         */

    }, {
        key: 'post',
        value: function post(url) {
            return this.submit('post', url);
        }

        /**
         * Send a PUT request to the given URL.
         * .
         * @param {string} url
         */

    }, {
        key: 'put',
        value: function put(url) {
            return this.submit('put', url);
        }

        /**
         * Send a PATCH request to the given URL.
         * .
         * @param {string} url
         */

    }, {
        key: 'patch',
        value: function patch(url) {
            return this.submit('patch', url);
        }

        /**
         * Send a DELETE request to the given URL.
         * .
         * @param {string} url
         */

    }, {
        key: 'delete',
        value: function _delete(url) {
            return this.submit('delete', url);
        }

        /**
         * Submit the form.
         *
         * @param {string} requestType
         * @param {string} url
         */

    }, {
        key: 'submit',
        value: function submit(requestType, url) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                Vue.prototype.$http[requestType](url, _this2.data()).then(function (response) {
                    _this2.onSuccess(response.data);

                    resolve(response.data);
                }).catch(function (error) {
                    _this2.onFail(error.response.data);

                    reject(error.response.data);
                });
            });
        }

        /**
         * Handle a successful form submission.
         *
         * @param {object} data
         */

    }, {
        key: 'onSuccess',
        value: function onSuccess(data) {}
        // console.log('[MyForm.js] 成功です',data);
        // this.reset();


        /**
         * Handle a failed form submission.
         *
         * @param {object} errors
         */

    }, {
        key: 'onFail',
        value: function onFail(errors) {
            console.warn('エラーです');
            console.warn(errors);
            this.errors.record(errors);
        }
    }]);

    return MyForm;
}();

exports.default = MyForm;

},{"../utils/TypeUtil":26,"./MyErrors":18}],20:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Vue.extend({
    data: function data() {
        return {
            fullScreen: $(document),
            firstView: $(window),

            fullScreenHeight: 0,
            firstViewHeight: 0,
            isBottom: false
        };
    },
    mounted: function mounted() {
        window.addEventListener('scroll', this.handleScrollY);
        this.init();
    },


    methods: {
        init: function init() {
            var fullScreen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var firstView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (fullScreen) {
                this.fullScreen = fullScreen;
            }

            if (firstView) {
                this.firstView = firstView;
            }

            this.firstViewHeight = this.firstView.height();
        },
        handleScrollY: function handleScrollY() {

            if (this.fullScreenHeight !== this.fullScreen.height()) {
                this.fullScreenHeight = this.fullScreen.height();
            }

            if (this.isScrolledToTheBottom()) {
                this.isBottom = true;
                Event.$emit('scrolled-to-the-bottom');
                return;
            }

            if (this.isBottom) {
                Event.$emit('scrolled-from-the-bottom');
            }

            this.isBottom = false;
        },
        isScrolledToTheBottom: function isScrolledToTheBottom() {
            return !this.isBottom && (this.fullScreenHeight - (this.firstViewHeight + this.firstView.scrollTop())) / this.fullScreenHeight === 0;
        }
    }
});

},{}],21:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * materials_1(work step post id)
 *   - material
 *   - material
 * user-tags_3(work step post id)
 *   - term_taxonomy
 *   - term_taxonomy
 * artifacts_4(work step post id)
 *   - artifact
 *   - artifact
 * term-tax-materials_12(term_taxonomy_id)
 *   - material
 *   - material
 *
 * */
var Session = function () {
    function Session() {
        _classCallCheck(this, Session);
    }

    _createClass(Session, null, [{
        key: 'available',
        value: function available() {
            return true && 'sessionStorage' in window && window.sessionStorage !== undefined;
        }
    }, {
        key: 'has',
        value: function has(prefix, id) {
            return undefined !== sessionStorage[this._makeKey(prefix, id)];
        }
    }, {
        key: 'get',
        value: function get(prefix, id) {
            return sessionStorage.getItem(this._makeKey(prefix, id));
        }
    }, {
        key: 'set',
        value: function set(prefix, id, value) {

            //TODO 動きがおかしいのセッション使わない
            return;

            if (!window.sessionStorage) {
                return;
            }

            try {
                sessionStorage.setItem(this._makeKey(prefix, id), value);
            } catch (err) {
                // SafariのプライベートブラウジングではsetItemだけ失敗してしまうためエラー処理する
                console.error(err);
            }
        }
    }, {
        key: '_makeKey',
        value: function _makeKey(prefix, id) {
            return prefix + '_' + id;
        }
    }]);

    return Session;
}();

exports.default = Session;

},{}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @field vue
 */
var VueJob = function VueJob(vue) {
    _classCallCheck(this, VueJob);

    this.vue = vue;
};

exports.default = VueJob;

},{}],23:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Collection = require('../Collection');

var _Collection2 = _interopRequireDefault(_Collection);

var _TypeUtil = require('../../utils/TypeUtil');

var _TypeUtil2 = _interopRequireDefault(_TypeUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Collection2.default.extend({
    props: {
        status: {
            default: ''
        }
    },

    computed: {
        length: function length() {
            return this.items.length;
        }
    },

    data: function data() {
        return {
            currentStatus: ''
        };
    },


    methods: {
        get: function get(post_or_id) {

            var post_id = _TypeUtil2.default.typeOfObject(post_or_id) ? post_or_id.ID : post_or_id;

            for (var idx in this.items) {

                if (!this.items.hasOwnProperty(idx)) {
                    continue;
                }

                if (this.items[idx] !== undefined && this.items[idx].ID !== undefined && parseInt(this.items[idx].ID) === parseInt(post_id)) {
                    return this.items[idx];
                }
            }

            return null;
        },
        getIndex: function getIndex(post_or_id) {

            var post_id = _TypeUtil2.default.typeOfObject(post_or_id) ? post_or_id.ID : post_or_id;

            for (var i = 0; i < this.items.length; i++) {
                if (parseInt(this.items[i].ID) === parseInt(post_id)) {
                    return i;
                }
            }
        },
        getById: function getById(post_id) {
            for (var i = 0; i < this.items.length; i++) {
                if (parseInt(this.items[i].ID) === parseInt(post_id)) {
                    return this.items[i];
                }
            }

            return false;
        },
        init: function init(collection, fn) {
            this.items = this.convert(collection, fn);
            this.$emit('added');
        },
        convert: function convert(collection, fn) {
            var posts = [];

            for (var idx in collection) {
                if (!collection.hasOwnProperty(idx)) {
                    continue;
                }

                posts[idx] = new fn(collection[idx]);
            }

            return posts;
        },
        toTop: function toTop(post_or_id) {

            var post = _TypeUtil2.default.typeOfObject(post_or_id) ? post_or_id : this.get(post_or_id);

            var index = this.getIndex(post_or_id);

            this.remove(index);

            this.unshift(post);
        },
        remove: function remove(index) {

            if (_TypeUtil2.default.typeOfNumber(index)) {
                this.items.splice(index, 1);
            } else {
                this.items.splice(this.getIndex(index), 1);
            }

            this.$emit('removed');
        },
        update: function update(post) {
            this.splice(this.getIndex(post), 1, post);
        }
    }

});

},{"../../utils/TypeUtil":26,"../Collection":14}],24:[function(require,module,exports){
'use strict';

var _ref;

require('./plugins/MyAxios');

var _RouteInput = require('./components/RouteInput.vue');

var _RouteInput2 = _interopRequireDefault(_RouteInput);

var _StationForm = require('./components/StationForm.vue');

var _StationForm2 = _interopRequireDefault(_StationForm);

var _TeacherList = require('./components/TeacherList.vue');

var _TeacherList2 = _interopRequireDefault(_TeacherList);

var _TeacherDetail = require('./components/TeacherDetail.vue');

var _TeacherDetail2 = _interopRequireDefault(_TeacherDetail);

var _PopularStations = require('./components/PopularStations.vue');

var _PopularStations2 = _interopRequireDefault(_PopularStations);

var _MessagePop = require('./components/MessagePop.vue');

var _MessagePop2 = _interopRequireDefault(_MessagePop);

var _Cache = require('./plugins/Cache');

var _Cache2 = _interopRequireDefault(_Cache);

var _URLUtil = require('./utils/URLUtil');

var _URLUtil2 = _interopRequireDefault(_URLUtil);

var _ScrollSpy = require('./plugins/ScrollSpy');

var _ScrollSpy2 = _interopRequireDefault(_ScrollSpy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // let Vue = require('vue');
// let vueUI = require('vue-ui');
// Vue.use(vueUI);


window.Event = new Vue();

new Vue((_ref = {
    el: '#app',

    mixins: [_ScrollSpy2.default],

    mounted: function mounted() {
        console.log('vue script is working!');
    },
    data: function data() {
        return {
            loading: false
        };
    },
    created: function created() {
        var _this = this;

        window.addEventListener('popstate', function (event) {
            var station_ids = void 0;
            if (station_ids = _URLUtil2.default.get_query('tt', false)) {
                _this.$nextTick(function () {
                    Event.$emit('station-was-selected', station_ids.split(','), false);
                });
            }
        });

        Event.$on('loading', function () {
            _this.loading = true;
        });

        Event.$on('loaded', function () {
            _this.loading = false;
        });

        Event.$on('scrolled-to-the-bottom', function () {
            Event.$emit('show-message', '<a href="/try">非公開の講師もいます。「希望講師」は空欄のまま、<span class="href">こちらからお問い合わせ</span>ください</a>');
        });

        Event.$on('scrolled-from-the-bottom', function () {
            Event.$emit('hide-message');
        });
    }
}, _defineProperty(_ref, 'mounted', function mounted() {

    var station_ids = void 0;
    if (station_ids = _URLUtil2.default.get_query('tt', false)) {
        Event.$emit('station-was-selected', station_ids.split(','));
        return;
    }

    if (_Cache2.default.has('last', 'stations')) {
        Event.$emit('station-was-selected', _Cache2.default.get('last', 'stations').split(','));
    }
}), _defineProperty(_ref, 'components', {
    RouteInput: _RouteInput2.default,
    StationForm: _StationForm2.default,
    TeacherList: _TeacherList2.default,
    TeacherDetail: _TeacherDetail2.default,
    PopularStations: _PopularStations2.default,
    MessagePop: _MessagePop2.default
}), _ref));

},{"./components/MessagePop.vue":3,"./components/PopularStations.vue":4,"./components/RouteInput.vue":5,"./components/StationForm.vue":6,"./components/TeacherDetail.vue":9,"./components/TeacherList.vue":10,"./plugins/Cache":13,"./plugins/MyAxios":16,"./plugins/ScrollSpy":20,"./utils/URLUtil":27}],25:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = {
    flatten: function flatten(ob) {
        var toReturn = {};

        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;

            if (_typeof(ob[i]) === 'object') {
                var flatObject = this.flatten(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;

                    toReturn[i + '.' + x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }
};

},{}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {

    /**
     * 型チェック。ただし独自クラスはチェックできない。
     * @see http://blog.ko-atrandom.com/?p=310
     * */
    typeOf: function typeOf(type, obj) {
        return type === Object.prototype.toString.call(obj).slice(8, -1);
    },


    //TODO 発生ベースで拡張していく
    typeOfObject: function typeOfObject(obj) {
        return this.typeOf('Object', obj);
    },
    typeOfString: function typeOfString(obj) {
        return this.typeOf('String', obj);
    },
    typeOfArray: function typeOfArray(obj) {
        return this.typeOf('Array', obj);
    },
    typeOfNumber: function typeOfNumber(obj) {
        return this.typeOf('Number', obj) && Number.isNaN !== undefined && !Number.isNaN(obj);
    }
};

},{}],27:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {

    /*******************************************************************************
     *
     * クエリからデータを取得する（簡易）
     * 何度も続けて取得する際には、get_query_from_urlを使うこと
     *
     ******************************************************************************/
    get_query: function get_query(key) {
        var empty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var q = this.get_query_from_url();
        return q[key] !== undefined ? q[key] : empty;
    },
    get_query_keys: function get_query_keys() {
        var keys = [];

        var q = this.get_query_from_url();

        for (var key in q) {

            if (q.hasOwnProperty(key)) {
                keys.push(key);
            }
        }

        return keys;
    },


    /******************************************************************
     *
     * クエリをURLから取得する
     *
     ******************************************************************/
    get_query_from_url: function get_query_from_url() {

        var queries = [];

        // クエリを取得する処理
        if ('' !== location.search) {
            var q = decodeURIComponent(location.search);
            q = q.substr(1).split('&');

            for (var i = 0; i < q.length; i++) {
                var params = q[i].split('=');

                if (params.length > 1) {
                    queries[params[0]] = params[1];
                } else {
                    queries[params[0]] = '';
                }
            }
        }

        return queries;
    }
};

},{}],28:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.find = find;
exports.deepCopy = deepCopy;
exports.forEachValue = forEachValue;
exports.isObject = isObject;
exports.isPromise = isPromise;
exports.assert = assert;
exports.empty = empty;
exports.array_equals = array_equals;
/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find(list, f) {
    var length = list.length;

    var index = 0;
    var value = void 0;
    while (++index < length) {
        value = list[index];
        if (f(value, index, list)) {
            return value;
        }
    }
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy(obj) {
    var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    // just return if obj is immutable value
    if (obj === null || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
        return obj;
    }

    // if obj is hit, it is in circular structure
    var hit = find(cache, function (c) {
        return c.original === obj;
    });
    if (hit) {
        return hit.copy;
    }

    var copy = Array.isArray(obj) ? [] : {};
    // put the copy into cache at first
    // because we want to refer it in recursive deepCopy
    cache.push({
        original: obj,
        copy: copy
    });

    Object.keys(obj).forEach(function (key) {
        copy[key] = deepCopy(obj[key], cache);
    });

    return copy;
}

/**
 * forEach for object
 */
function forEachValue(obj, fn) {
    Object.keys(obj).forEach(function (key) {
        return fn(obj[key], key);
    });
}

function isObject(obj) {
    return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

function isPromise(val) {
    return val && typeof val.then === 'function';
}

function assert(condition, msg) {
    if (!condition) throw new Error('[vuex] ' + msg);
}

/***************************
 *
 * 空判定
 *
 ***************************/
function empty(obj) {
    return typeof obj === 'undefined' || obj === null || obj === '' || obj.length === 0;
}

/***************************
 *
 * 同一配列判定
 * @see http://marycore.jp/prog/js/array-equal/
 *
 ***************************/
function array_equals(arr1, arr2) {
    return arr1.sort().toString() == arr2.sort().toString();
}

},{}],29:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],30:[function(require,module,exports){
var Vue // late bind
var map = Object.create(null)
var shimmed = false
var isBrowserify = false

/**
 * Determine compatibility and apply patch.
 *
 * @param {Function} vue
 * @param {Boolean} browserify
 */

exports.install = function (vue, browserify) {
  if (shimmed) return
  shimmed = true

  Vue = vue
  isBrowserify = browserify

  exports.compatible = !!Vue.internalDirectives
  if (!exports.compatible) {
    console.warn(
      '[HMR] vue-loader hot reload is only compatible with ' +
      'Vue.js 1.0.0+.'
    )
    return
  }

  // patch view directive
  patchView(Vue.internalDirectives.component)
  console.log('[HMR] Vue component hot reload shim applied.')
  // shim router-view if present
  var routerView = Vue.elementDirective('router-view')
  if (routerView) {
    patchView(routerView)
    console.log('[HMR] vue-router <router-view> hot reload shim applied.')
  }
}

/**
 * Shim the view directive (component or router-view).
 *
 * @param {Object} View
 */

function patchView (View) {
  var unbuild = View.unbuild
  View.unbuild = function (defer) {
    if (!this.hotUpdating) {
      var prevComponent = this.childVM && this.childVM.constructor
      removeView(prevComponent, this)
      // defer = true means we are transitioning to a new
      // Component. Register this new component to the list.
      if (defer) {
        addView(this.Component, this)
      }
    }
    // call original
    return unbuild.call(this, defer)
  }
}

/**
 * Add a component view to a Component's hot list
 *
 * @param {Function} Component
 * @param {Directive} view - view directive instance
 */

function addView (Component, view) {
  var id = Component && Component.options.hotID
  if (id) {
    if (!map[id]) {
      map[id] = {
        Component: Component,
        views: [],
        instances: []
      }
    }
    map[id].views.push(view)
  }
}

/**
 * Remove a component view from a Component's hot list
 *
 * @param {Function} Component
 * @param {Directive} view - view directive instance
 */

function removeView (Component, view) {
  var id = Component && Component.options.hotID
  if (id) {
    map[id].views.$remove(view)
  }
}

/**
 * Create a record for a hot module, which keeps track of its construcotr,
 * instnaces and views (component directives or router-views).
 *
 * @param {String} id
 * @param {Object} options
 */

exports.createRecord = function (id, options) {
  if (typeof options === 'function') {
    options = options.options
  }
  if (typeof options.el !== 'string' && typeof options.data !== 'object') {
    makeOptionsHot(id, options)
    map[id] = {
      Component: null,
      views: [],
      instances: []
    }
  }
}

/**
 * Make a Component options object hot.
 *
 * @param {String} id
 * @param {Object} options
 */

function makeOptionsHot (id, options) {
  options.hotID = id
  injectHook(options, 'created', function () {
    var record = map[id]
    if (!record.Component) {
      record.Component = this.constructor
    }
    record.instances.push(this)
  })
  injectHook(options, 'beforeDestroy', function () {
    map[id].instances.$remove(this)
  })
}

/**
 * Inject a hook to a hot reloadable component so that
 * we can keep track of it.
 *
 * @param {Object} options
 * @param {String} name
 * @param {Function} hook
 */

function injectHook (options, name, hook) {
  var existing = options[name]
  options[name] = existing
    ? Array.isArray(existing)
      ? existing.concat(hook)
      : [existing, hook]
    : [hook]
}

/**
 * Update a hot component.
 *
 * @param {String} id
 * @param {Object|null} newOptions
 * @param {String|null} newTemplate
 */

exports.update = function (id, newOptions, newTemplate) {
  var record = map[id]
  // force full-reload if an instance of the component is active but is not
  // managed by a view
  if (!record || (record.instances.length && !record.views.length)) {
    console.log('[HMR] Root or manually-mounted instance modified. Full reload may be required.')
    if (!isBrowserify) {
      window.location.reload()
    } else {
      // browserify-hmr somehow sends incomplete bundle if we reload here
      return
    }
  }
  if (!isBrowserify) {
    // browserify-hmr already logs this
    console.log('[HMR] Updating component: ' + format(id))
  }
  var Component = record.Component
  // update constructor
  if (newOptions) {
    // in case the user exports a constructor
    Component = record.Component = typeof newOptions === 'function'
      ? newOptions
      : Vue.extend(newOptions)
    makeOptionsHot(id, Component.options)
  }
  if (newTemplate) {
    Component.options.template = newTemplate
  }
  // handle recursive lookup
  if (Component.options.name) {
    Component.options.components[Component.options.name] = Component
  }
  // reset constructor cached linker
  Component.linker = null
  // reload all views
  record.views.forEach(function (view) {
    updateView(view, Component)
  })
  // flush devtools
  if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__) {
    window.__VUE_DEVTOOLS_GLOBAL_HOOK__.emit('flush')
  }
}

/**
 * Update a component view instance
 *
 * @param {Directive} view
 * @param {Function} Component
 */

function updateView (view, Component) {
  if (!view._bound) {
    return
  }
  view.Component = Component
  view.hotUpdating = true
  // disable transitions
  view.vm._isCompiled = false
  // save state
  var state = extractState(view.childVM)
  // remount, make sure to disable keep-alive
  var keepAlive = view.keepAlive
  view.keepAlive = false
  view.mountComponent()
  view.keepAlive = keepAlive
  // restore state
  restoreState(view.childVM, state, true)
  // re-eanble transitions
  view.vm._isCompiled = true
  view.hotUpdating = false
}

/**
 * Extract state from a Vue instance.
 *
 * @param {Vue} vm
 * @return {Object}
 */

function extractState (vm) {
  return {
    cid: vm.constructor.cid,
    data: vm.$data,
    children: vm.$children.map(extractState)
  }
}

/**
 * Restore state to a reloaded Vue instance.
 *
 * @param {Vue} vm
 * @param {Object} state
 */

function restoreState (vm, state, isRoot) {
  var oldAsyncConfig
  if (isRoot) {
    // set Vue into sync mode during state rehydration
    oldAsyncConfig = Vue.config.async
    Vue.config.async = false
  }
  // actual restore
  if (isRoot || !vm._props) {
    vm.$data = state.data
  } else {
    Object.keys(state.data).forEach(function (key) {
      if (!vm._props[key]) {
        // for non-root, only restore non-props fields
        vm.$data[key] = state.data[key]
      }
    })
  }
  // verify child consistency
  var hasSameChildren = vm.$children.every(function (c, i) {
    return state.children[i] && state.children[i].cid === c.constructor.cid
  })
  if (hasSameChildren) {
    // rehydrate children
    vm.$children.forEach(function (c, i) {
      restoreState(c, state.children[i])
    })
  }
  if (isRoot) {
    Vue.config.async = oldAsyncConfig
  }
}

function format (id) {
  var match = id.match(/[^\/]+\.vue$/)
  return match ? match[0] : id
}

},{}],31:[function(require,module,exports){
(function (process,global){
/*!
 * Vue.js v2.5.3
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
'use strict';

/*  */

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */


/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: process.env.NODE_ENV !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: process.env.NODE_ENV !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

var emptyObject = Object.freeze({});

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (process.env.NODE_ENV !== 'production') {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid$1 = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid$1++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.functionalContext = undefined;
  this.functionalOptions = undefined;
  this.functionalScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode, deep) {
  var componentOptions = vnode.componentOptions;
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.isCloned = true;
  if (deep) {
    if (vnode.children) {
      cloned.children = cloneVNodes(vnode.children, true);
    }
    if (componentOptions && componentOptions.children) {
      componentOptions.children = cloneVNodes(componentOptions.children, true);
    }
  }
  return cloned
}

function cloneVNodes (vnodes, deep) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i], deep);
  }
  return res
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
]
.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (process.env.NODE_ENV !== 'production' && customSetter) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    process.env.NODE_ENV !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    process.env.NODE_ENV !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (process.env.NODE_ENV !== 'production') {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      process.env.NODE_ENV !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    process.env.NODE_ENV !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (process.env.NODE_ENV !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && process.env.NODE_ENV !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    var lower = key.toLowerCase();
    if (isBuiltInTag(lower) || config.isReservedTag(lower)) {
      warn(
        'Do not use built-in or reserved HTML elements as component ' +
        'id: ' + key
      );
    }
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (process.env.NODE_ENV !== 'production') {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (process.env.NODE_ENV !== 'production') {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (process.env.NODE_ENV !== 'production' && inject) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (process.env.NODE_ENV !== 'production') {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (process.env.NODE_ENV !== 'production' && warnMissing && !res) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (process.env.NODE_ENV !== 'production') {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (process.env.NODE_ENV !== 'production' && isObject(def)) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (process.env.NODE_ENV !== 'production') {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if (inBrowser && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both micro and macro tasks.
// In < 2.4 we used micro tasks everywhere, but there are some scenarios where
// micro tasks have too high a priority and fires in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using macro tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use micro task by default, but expose a way to force macro task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) Task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine MicroTask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a Task instead of a MicroTask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (process.env.NODE_ENV !== 'production') {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

var mark;
var measure;

if (process.env.NODE_ENV !== 'production') {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, cur, old, event;
  for (name in on) {
    cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      process.env.NODE_ENV !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (process.env.NODE_ENV !== 'production') {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      process.env.NODE_ENV !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                process.env.NODE_ENV !== 'production'
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (process.env.NODE_ENV !== 'production') {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.functionalContext === context) &&
      data && data.slot != null
    ) {
      var name = child.data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return node.isComment || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (process.env.NODE_ENV !== 'production') {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (process.env.NODE_ENV !== 'production' && config.performance && mark) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  vm._watcher = new Watcher(vm, updateComponent, noop);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (process.env.NODE_ENV !== 'production') {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = (parentVnode.data && parentVnode.data.attrs) || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (process.env.NODE_ENV !== 'production') {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (process.env.NODE_ENV !== 'production') {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (process.env.NODE_ENV !== 'production' && has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options
) {
  this.vm = vm;
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression = process.env.NODE_ENV !== 'production'
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      process.env.NODE_ENV !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
var seenObjects = new _Set();
function traverse (val) {
  seenObjects.clear();
  _traverse(val, seenObjects);
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || !Object.isExtensible(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== 'production') {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    process.env.NODE_ENV !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (process.env.NODE_ENV !== 'production') {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      process.env.NODE_ENV !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (process.env.NODE_ENV !== 'production' && getter == null) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (process.env.NODE_ENV !== 'production') {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (process.env.NODE_ENV !== 'production' &&
      sharedPropertyDefinition.set === noop) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (process.env.NODE_ENV !== 'production') {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  keyOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(keyOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (process.env.NODE_ENV !== 'production') {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    observerState.shouldConvert = false;
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== 'production') {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    observerState.shouldConvert = true;
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
        ? Reflect.ownKeys(inject).filter(function (key) {
          /* istanbul ignore next */
          return Object.getOwnPropertyDescriptor(inject, key).enumerable
        })
        : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (process.env.NODE_ENV !== 'production') {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (process.env.NODE_ENV !== 'production' && !isObject(bindObject)) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (process.env.NODE_ENV !== 'production' && slotNodes._rendered) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias,
  eventKeyName
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (keyCodes) {
    if (Array.isArray(keyCodes)) {
      return keyCodes.indexOf(eventKeyCode) === -1
    } else {
      return keyCodes !== eventKeyCode
    }
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      process.env.NODE_ENV !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  // static trees can be rendered once and cached on the contructor options
  // so every instance shares the same cached trees
  var options = this.$options;
  var cached = options.cached || (options.cached = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = options.staticRenderFns[index].call(this._renderProxy, null, this);
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      process.env.NODE_ENV !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm = Object.create(parent);
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode) {
        vnode.functionalScopeId = options._scopeId;
        vnode.functionalContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    vnode.functionalContext = contextVm;
    vnode.functionalOptions = options;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }

  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (process.env.NODE_ENV !== 'production') {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var vnodeComponentOptions = vnode.componentOptions;
  var options = {
    _isComponent: true,
    parent: parent,
    propsData: vnodeComponentOptions.propsData,
    _componentTag: vnodeComponentOptions.tag,
    _parentVnode: vnode,
    _parentListeners: vnodeComponentOptions.listeners,
    _renderChildren: vnodeComponentOptions.children,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnodeComponentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    process.env.NODE_ENV !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (process.env.NODE_ENV !== 'production' &&
    isDef(data) && isDef(data.key) && !isPrimitive(data.key)
  ) {
    warn(
      'Avoid using non-primitive value as key, ' +
      'use string/number value instead.',
      context
    );
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (isDef(vnode)) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force))) {
        applyNS(child, ns, force);
      }
    }
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (process.env.NODE_ENV !== 'production') {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // if the parent didn't update, the slot nodes will be the ones from
      // last render. They need to be cloned to ensure "freshness" for this render.
      for (var key in vm.$slots) {
        var slot = vm.$slots[key];
        if (slot._rendered) {
          vm.$slots[key] = cloneVNodes(slot, true /* deep */);
        }
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== 'production') {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (process.env.NODE_ENV !== 'production' && Array.isArray(vnode)) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (process.env.NODE_ENV !== 'production' && config.performance && mark) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== 'production') {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (process.env.NODE_ENV !== 'production' && config.performance && mark) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  opts.parent = options.parent;
  opts.propsData = options.propsData;
  opts._parentVnode = options._parentVnode;
  opts._parentListeners = options._parentListeners;
  opts._renderChildren = options._renderChildren;
  opts._componentTag = options._componentTag;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;
  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if (process.env.NODE_ENV !== 'production' &&
    !(this instanceof Vue$3)
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (process.env.NODE_ENV !== 'production') {
      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
        warn(
          'Invalid component name: "' + name + '". Component names ' +
          'can only contain alphanumeric characters and the hyphen, ' +
          'and must start with a letter.'
        );
      }
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (process.env.NODE_ENV !== 'production') {
          if (type === 'component' && config.isReservedTag(id)) {
            warn(
              'Do not use built-in or reserved HTML elements as component ' +
              'id: ' + id
            );
          }
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && cached$$1 !== current) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var vnode = getFirstComponentChild(this.$slots.default);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      if (name && (
        (this.exclude && matches(this.exclude, name)) ||
        (this.include && !matches(this.include, name))
      )) {
        return vnode
      }

      var ref = this;
      var cache = ref.cache;
      var keys = ref.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (process.env.NODE_ENV !== 'production') {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$3.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

Vue$3.version = '2.5.3';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);



var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      process.env.NODE_ENV !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  var inPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (process.env.NODE_ENV !== 'production') {
        if (data && data.pre) {
          inPre++;
        }
        if (
          !inPre &&
          !vnode.ns &&
          !(
            config.ignoredElements.length &&
            config.ignoredElements.some(function (ignore) {
              return isRegExp(ignore)
                ? ignore.test(tag)
                : ignore === tag
            })
          ) &&
          config.isUnknownElement(tag)
        ) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (process.env.NODE_ENV !== 'production' && data && data.pre) {
        inPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(vnode.text));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.functionalScopeId)) {
      nodeOps.setAttribute(vnode.elm, i, '');
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setAttribute(vnode.elm, i, '');
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.functionalContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
        } else {
          vnodeToMove = oldCh[idxInOld];
          /* istanbul ignore if */
          if (process.env.NODE_ENV !== 'production' && !vnodeToMove) {
            warn(
              'It seems there are duplicate keys that is causing an update error. ' +
              'Make sure each v-for item has a unique key.'
            );
          }
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var bailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  var isRenderedModule = makeMap('attrs,style,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue) {
    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.elm = elm;
      vnode.isAsyncPlaceholder = true;
      return true
    }
    if (process.env.NODE_ENV !== 'production') {
      if (!assertNodeMatch(elm, vnode)) {
        return false
      }
    }
    vnode.elm = elm;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (process.env.NODE_ENV !== 'production' &&
                typeof console !== 'undefined' &&
                !bailed
              ) {
                bailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (process.env.NODE_ENV !== 'production' &&
                typeof console !== 'undefined' &&
                !bailed
              ) {
                bailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        for (var key in data) {
          if (!isRenderedModule(key)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode) {
    if (isDef(vnode.tag)) {
      return (
        vnode.tag.indexOf('vue-component') === 0 ||
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (process.env.NODE_ENV !== 'production') {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE9 || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

/*  */















// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.

/*  */

/**
 * Cross-platform code generation for component v-model
 */


/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */

/*  */

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isDirty(elm, checkVal) ||
    isInputChanged(elm, checkVal)
  ))
}

function isDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isInputChanged (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers) && modifiers.number) {
    return toNumber(value) !== toNumber(newVal)
  }
  if (isDef(modifiers) && modifiers.trim) {
    return value.trim() !== newVal.trim()
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (childNode.data && (styleData = normalizeStyleData(childNode.data))) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (process.env.NODE_ENV !== 'production' && explicitEnterDuration != null) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (process.env.NODE_ENV !== 'production' && isDef(explicitLeaveDuration)) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    process.env.NODE_ENV !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$options._renderChildren;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (process.env.NODE_ENV !== 'production' && children.length > 1) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (process.env.NODE_ENV !== 'production' &&
      mode && mode !== 'in-out' && mode !== 'out-in'
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (process.env.NODE_ENV !== 'production') {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
Vue$3.nextTick(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if (process.env.NODE_ENV !== 'production' && isChrome) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if (process.env.NODE_ENV !== 'production' &&
    config.productionTip !== false &&
    inBrowser && typeof console !== 'undefined'
  ) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

module.exports = Vue$3;

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":29}]},{},[24]);
